// // // import React from 'react'

// // // const SuperAdminStaffGoals = () => {
// // //   return (
// // //     <div>SuperAdminStaffGoals</div>
// // //   )
// // // }

// // // export default SuperAdminStaffGoals

// // // import React, { useEffect, useMemo, useState } from "react";
// // // import styled from "styled-components";
// // // import { useParams, useNavigate } from "react-router-dom";
// // // import { FaArrowLeft } from "react-icons/fa";
// // // import NavBarSuper from "./NavBarSuper";
// // // import Footer from "./Footer";
// // // import api from "../api";

// // // /* ================= HELPERS ================= */
// // // const getCurrentMonthName = () => {
// // //   const date = new Date();
// // //   return date.toLocaleString("default", { month: "long", year: "numeric" });
// // // };

// // // // Generate a list of months for the dropdown (3 months past, 9 months future)
// // // const generateMonthOptions = () => {
// // //   const months = [];
// // //   const date = new Date();
// // //   date.setMonth(date.getMonth() - 3); 
// // //   for (let i = 0; i < 12; i++) {
// // //     months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
// // //     date.setMonth(date.getMonth() + 1);
// // //   }
// // //   return months;
// // // };

// // // // Format "April 2026" to "2026-04" for backend queries
// // // const formatToYearMonth = (periodString) => {
// // //   if (!periodString) return "";
// // //   const d = new Date(periodString);
// // //   if (isNaN(d.getTime())) return "";
// // //   const y = d.getFullYear();
// // //   const m = String(d.getMonth() + 1).padStart(2, "0");
// // //   return `${y}-${m}`;
// // // };

// // // const getWeekLabel = (dateInput) => {
// // //   if (!dateInput) return "Unknown Week";
// // //   let date;
// // //   if (dateInput instanceof Date) {
// // //     date = dateInput;
// // //   } else if (typeof dateInput === 'string') {
// // //     const datePart = dateInput.includes('T') ? dateInput.split('T')[0] : dateInput;
// // //     const parts = datePart.split('-'); 
// // //     if (parts.length !== 3) return "Invalid Date";
// // //     date = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
// // //   } else {
// // //     return "Invalid Date";
// // //   }
// // //   if (isNaN(date.getTime())) return "Invalid Date";
// // //   const sunday = new Date(date);
// // //   sunday.setDate(date.getDate() - date.getDay());
// // //   const saturday = new Date(sunday);
// // //   saturday.setDate(sunday.getDate() + 6);
// // //   const getWeekNum = (d) => {
// // //     const firstDay = new Date(d.getFullYear(), d.getMonth(), 1).getDay();
// // //     return Math.ceil((d.getDate() + firstDay) / 7);
// // //   };
// // //   if (sunday.getMonth() === saturday.getMonth()) {
// // //     return `Week ${getWeekNum(saturday)}`;
// // //   } else {
// // //     const nextMonthName = saturday.toLocaleString("default", { month: "long" });
// // //     return `Week ${getWeekNum(sunday)} / ${nextMonthName} Week ${getWeekNum(saturday)}`;
// // //   }
// // // };

// // // const formatNiceDate = (dateString) => {
// // //   if (!dateString) return "—";
// // //   const date = new Date(dateString);
// // //   if (isNaN(date.getTime())) return "Invalid date";
// // //   const month = date.toLocaleString("default", { month: "long" });
// // //   const day = date.getDate();
// // //   const year = date.getFullYear();
// // //   let suffix = "th";
// // //   if (day % 10 === 1 && day % 100 !== 11) suffix = "st";
// // //   else if (day % 10 === 2 && day % 100 !== 12) suffix = "nd";
// // //   else if (day % 10 === 3 && day % 100 !== 13) suffix = "rd";
// // //   return `${month} ${day}${suffix}, ${year}`;
// // // };

// // // const getGoalUnit = (goal) => {
// // //   let unitVal = goal.unit || goal.subDepartment || "";
// // //   if (typeof unitVal !== 'string') {
// // //     unitVal = String(unitVal);
// // //   }
// // //   return unitVal;
// // // };

// // // /* ================= PAGE LAYOUT ================= */
// // // const Container = styled.div`
// // //   display: flex;
// // //   flex-direction: column;
// // //   min-height: 100vh;
// // //   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// // // `;

// // // const PageWrapper = styled.div`
// // //   flex: 1 0 auto;
// // //   width: min(1380px, calc(100% - 32px));
// // //   margin: 90px auto 40px;

// // //   @media (max-width: 768px) {
// // //     width: min(100%, calc(100% - 20px));
// // //     margin-top: 80px;
// // //   }
// // // `;

// // // const HeaderSection = styled.div`
// // //   display: flex;
// // //   justify-content: space-between;
// // //   align-items: center;
// // //   flex-wrap: wrap;
// // //   gap: 16px;
// // //   margin-bottom: 24px;
// // // `;

// // // const BackButton = styled.button`
// // //   display: inline-flex;
// // //   align-items: center;
// // //   gap: 8px;
// // //   background: none;
// // //   border: none;
// // //   color: #1d4ed8;
// // //   font-weight: 800;
// // //   font-size: 1rem;
// // //   cursor: pointer;
// // //   transition: transform 0.2s ease;
// // //   padding: 0;

// // //   &:hover {
// // //     transform: translateX(-4px);
// // //   }
// // // `;

// // // const HeroCard = styled.div`
// // //   background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #1d4ed8 100%);
// // //   color: #fff;
// // //   border-radius: 24px;
// // //   padding: 32px;
// // //   margin-bottom: 24px;
// // //   box-shadow: 0 15px 35px rgba(15, 23, 42, 0.1);
// // //   display: flex;
// // //   justify-content: space-between;
// // //   align-items: center;
// // //   flex-wrap: wrap;
// // //   gap: 20px;
// // // `;

// // // const HeroTitle = styled.h1`
// // //   margin: 0 0 10px;
// // //   font-size: clamp(1.6rem, 1.2rem + 1.2vw, 2.4rem);
// // //   font-weight: 800;
// // // `;

// // // const HeroText = styled.p`
// // //   margin: 0;
// // //   color: rgba(255, 255, 255, 0.86);
// // //   font-size: 1.05rem;
// // //   max-width: 800px;
// // //   line-height: 1.5;
// // // `;

// // // /* ================= CARDS / TABLES ================= */
// // // const Card = styled.div`
// // //   background: rgba(255, 255, 255, 0.96);
// // //   border-radius: 28px;
// // //   padding: 24px;
// // //   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
// // //   border: 1px solid rgba(148, 163, 184, 0.16);
// // //   margin-bottom: 34px;

// // //   @media (max-width: 768px) { padding: 18px; border-radius: 22px; }
// // // `;

// // // const TitleRow = styled.div`
// // //   display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 10px;
// // // `;

// // // const SectionTitle = styled.h2`
// // //   font-size: clamp(1.15rem, 1rem + 0.6vw, 1.5rem); color: #1f2937; margin: 0; font-weight: 800;
// // // `;

// // // const GlobalMonthSelect = styled.select`
// // //   padding: 6px 16px; border-radius: 12px; border: 2px solid #bfdbfe; font-size: 1.1rem;
// // //   font-weight: 800; color: #1d4ed8; background: #eff6ff; outline: none; cursor: pointer; transition: all 0.2s;
// // //   &:focus { border-color: #3b82f6; box-shadow: 0 0 0 4px rgba(59,130,246,0.1); }
// // // `;

// // // const Subtitle = styled.p` color: #6b7280; margin: 0 0 24px; font-size: 0.98rem; line-height: 1.6; `;

// // // /* ================= BADGES ================= */
// // // const UnitBadge = styled.span`
// // //   display: inline-block; padding: 5px 10px; background: #e0f2fe; color: #0369a1; border: 1px solid #bae6fd;
// // //   border-radius: 6px; font-size: 11px; font-weight: 800; letter-spacing: 0.05em; text-transform: uppercase;
// // // `;

// // // /* ================= GOALS TABLE DESKTOP ================= */
// // // const GoalsTableContainer = styled.div`
// // //   border-radius: 18px; border: 1px solid #e2e8f0; background: white; width: 100%; overflow: hidden;
// // //   @media (max-width: 900px) { display: none; }
// // // `;

// // // const GoalsTable = styled.table` width: 100%; border-collapse: collapse; background: white; table-layout: fixed; `;
// // // const Th = styled.th` background: #f8fafc; padding: 18px 20px; text-align: left; font-weight: 700; color: #1e293b; border-bottom: 2px solid #e2e8f0; font-size: 14px; `;
// // // const Td = styled.td` padding: 18px 20px; border-bottom: 1px solid #f1f5f9; color: #1f2937; font-size: 15px; vertical-align: top; white-space: normal; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; max-width: 0; `;
// // // const MonthlyTr = styled.tr` background: #f0f9ff; `;
// // // const WeeklyTr = styled.tr` background: #fff; `;
// // // const MonthlyBlock = styled.div` padding: 8px 0; `;
// // // const MonthlyTag = styled.div` color: #1e40af; font-size: 13px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; `;
// // // const RoutineTag = styled(MonthlyTag)` color: #ea580c; `;
// // // const GoalText = styled.div` margin-top: 10px; font-weight: 700; font-size: 16px; line-height: 1.5; color: #0f172a; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; white-space: normal; width: 100%; `;
// // // const GoalMeta = styled.div` margin-top: 6px; color: #2563eb; font-size: 14px; font-weight: 700; line-height: 1.5; `;
// // // const WeeklyGoalWrap = styled.div` display: grid; gap: 6px; min-width: 0; position: relative; padding-left: 16px; border-left: 2px solid #cbd5f5; &::before { content: ""; position: absolute; left: -6px; top: 16px; width: 10px; height: 2px; background: #3b82f6; } `;
// // // const WeeklyTitle = styled.div` font-weight: 800; font-size: 12px; color: #1d4ed8; text-transform: uppercase; letter-spacing: 0.04em; display: flex; align-items: center; gap: 6px; &::before { content: "→"; font-size: 14px; color: #3b82f6; } `;
// // // const NoData = styled.p` text-align: center; color: #6b7280; font-style: italic; padding: 60px 20px; font-size: 15.5px; `;

// // // const ReadOnlyText = styled.div`
// // //   width: 100%; min-height: 60px; padding: 14px; font-size: 14px; line-height: 1.6;
// // //   background: #f8fafc; color: #334155; border-radius: 12px; border: 1px solid #e2e8f0;
// // //   white-space: pre-wrap;
// // // `;

// // // const EmptyStateText = styled(ReadOnlyText)`
// // //   color: #94a3b8; font-style: italic; background: #fdfdfd; border: 1px dashed #cbd5e1;
// // // `;

// // // /* ================= RESPONSIVE GOAL CARDS ================= */
// // // const GoalsMobileGrid = styled.div` display: none; @media (max-width: 900px) { display: grid; gap: 16px; } `;
// // // const GoalCard = styled.div` background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%); border: 1px solid rgba(148, 163, 184, 0.18); border-left: 5px solid ${({ variant }) => (variant === "routine" ? "#ea580c" : "#3b82f6")}; border-radius: 22px; padding: 18px; box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06); position: relative; `;
// // // const GoalCardHeader = styled.div` display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; flex-wrap: wrap; margin-bottom: 14px; `;
// // // const Pill = styled.div` display: inline-flex; align-items: center; padding: 8px 12px; border-radius: 999px; font-size: 12px; font-weight: 800; letter-spacing: 0.04em; text-transform: uppercase; background: ${({ variant }) => variant === "routine" ? "rgba(234, 88, 12, 0.12)" : "rgba(37,99,235,0.12)"}; color: ${({ variant }) => (variant === "routine" ? "#ea580c" : "#1d4ed8")}; `;
// // // const GoalCardTitle = styled.div` font-size: 1rem; font-weight: 800; line-height: 1.5; color: #0f172a; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; white-space: normal; `;
// // // const GoalCardMeta = styled.div` margin-top: 6px; font-size: 14px; color: #64748b; line-height: 1.5; `;
// // // const SmallLabel = styled.div` font-size: 12px; font-weight: 800; color: #64748b; margin: 14px 0 6px; text-transform: uppercase; letter-spacing: 0.04em; `;
// // // const EmptyCard = styled.div` padding: 28px 20px; text-align: center; border-radius: 18px; background: #f8fafc; border: 1px dashed #cbd5e1; color: #64748b; `;

// // // /* ================= PAGINATION ================= */
// // // const PaginationContainer = styled.div` display: flex; justify-content: center; align-items: center; gap: 12px; margin-top: 28px; flex-wrap: wrap; `;
// // // const PageButton = styled.button` padding: 10px 18px; border: 1px solid #cbd5e1; background: white; border-radius: 9999px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; &:hover:not(:disabled) { background: #f1f5f9; transform: translateY(-1px); color: #1e40af; } &:disabled { opacity: 0.5; cursor: not-allowed; } &.active { background: #1e40af; color: white; border-color: #1e40af; } `;

// // // /* ================= STATES ================= */
// // // const StateBox = styled.div`
// // //   text-align: center; padding: 50px 20px; border-radius: 18px;
// // //   background: ${({ type }) => type === 'error' ? '#fef2f2' : '#ffffff'};
// // //   color: ${({ type }) => type === 'error' ? '#dc2626' : '#64748b'};
// // //   border: 1px solid ${({ type }) => type === 'error' ? '#fecaca' : '#e2e8f0'};
// // //   font-size: 1rem;
// // // `;

// // // const Spinner = styled.div`
// // //   width: 40px; height: 40px; margin: 0 auto 16px; border-radius: 50%;
// // //   border: 4px solid #e0ecff; border-top-color: #1d4ed8; animation: spin 0.8s linear infinite;
// // //   @keyframes spin { to { transform: rotate(360deg); } }
// // // `;

// // // /* ================= COMPONENT ================= */
// // // const SuperAdminStaffGoals = ({ user }) => {
// // //   const { userId } = useParams();
// // //   const navigate = useNavigate();
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);
// // //   const [staffInfo, setStaffInfo] = useState(null);

// // //   const availableMonths = useMemo(() => generateMonthOptions(), []);
  
// // //   // Use a different storage key so it doesn't conflict with their own dashboard state
// // //   const [selectedMonth, setSelectedMonth] = useState(
// // //     localStorage.getItem("superAdminViewMonth") || getCurrentMonthName()
// // //   );

// // //   const [submittedGoals, setSubmittedGoals] = useState([]);
// // //   const [currentPage, setCurrentPage] = useState(1);

// // //   useEffect(() => {
// // //     localStorage.setItem("superAdminViewMonth", selectedMonth);
// // //   }, [selectedMonth]);

  
// // //   useEffect(() => {
// // //     const fetchStaffGoals = async () => {
// // //       try {
// // //         setLoading(true);
// // //         setError(null);
        
// // //         // We need to fetch the goals for this specific user. 
// // //         const targetMonthParam = formatToYearMonth(selectedMonth);
        
// // //         const res = await api.get(`/goals/admin/user-month/${userId}?targetMonth=${targetMonthParam}`);
        
// // //         setSubmittedGoals(res.data.data || []);
// // //         if (res.data.staff) setStaffInfo(res.data.staff);
        
// // //       } catch (err) {
// // //         console.error(err);
// // //         setError(err.response?.data?.message || 'Failed to fetch staff goals');
// // //         setSubmittedGoals([]);
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     };

// // //     if (userId) {
// // //       fetchStaffGoals();
// // //     }
// // //   }, [userId, selectedMonth]);

// // //   const monthlyGoals = submittedGoals.filter((g) => g.type === "monthly");
// // //   const weeklyGoals = submittedGoals.filter((g) => g.type === "weekly");
// // //   const routineGoals = submittedGoals.filter((g) => g.type === "routine");

// // //   const descendingWeeklyGoals = [...weeklyGoals].sort((a, b) => new Date(b.weeklyDeliveryDate).getTime() - new Date(a.weeklyDeliveryDate).getTime());
// // //   const weeks = [...new Set(descendingWeeklyGoals.map((w) => getWeekLabel(w.weeklyDeliveryDate)))];
// // //   const maxPages = Math.max(weeks.length, 1);
// // //   const displayWeek = weeks[currentPage - 1] || getWeekLabel(new Date());
  
// // //   const filteredWeeklies = weeklyGoals.filter((w) => getWeekLabel(w.weeklyDeliveryDate) === displayWeek);

// // //   const renderReadOnlyField = (content, placeholder) => {
// // //     if (!content || !content.trim()) {
// // //       return <EmptyStateText>{placeholder}</EmptyStateText>;
// // //     }
// // //     return <ReadOnlyText>{content}</ReadOnlyText>;
// // //   };

// // //   return (
// // //     <Container>
// // //       <NavBarSuper user={user} />

// // //       <PageWrapper>
// // //         <HeaderSection>
// // //           <BackButton onClick={() => navigate('/super-admin/dashboard')}>
// // //             <FaArrowLeft /> Back to Directory
// // //           </BackButton>
// // //         </HeaderSection>

// // //         <HeroCard>
// // //           <div>
// // //             <HeroTitle>Staff Goal Review</HeroTitle>
// // //             <HeroText>
// // //               Reviewing the submitted goals, achievements, and comments for <strong>{staffInfo?.firstName || 'this staff member'}</strong>.
// // //             </HeroText>
// // //           </div>
// // //         </HeroCard>

// // //         <Card>
// // //           <TitleRow>
// // //             <SectionTitle>Viewing Goals for</SectionTitle>
// // //             <GlobalMonthSelect value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
// // //               {availableMonths.map(m => (
// // //                 <option key={m} value={m}>{m}</option>
// // //               ))}
// // //             </GlobalMonthSelect>
// // //           </TitleRow>

// // //           <Subtitle>
// // //             This view is read-only. To score these achievements, return to the dashboard and open their Appraisal Submission.
// // //           </Subtitle>

// // //           {loading ? (
// // //             <StateBox>
// // //               <Spinner />
// // //               Loading staff records...
// // //             </StateBox>
// // //           ) : error ? (
// // //             <StateBox type="error">{error}</StateBox>
// // //           ) : (
// // //             <>
// // //               {/* DESKTOP TABLE */}
// // //               <GoalsTableContainer>
// // //                 <GoalsTable>
// // //                   <thead>
// // //                     <tr>
// // //                       <Th style={{ width: "40%" }}>Goals</Th>
// // //                       <Th style={{ width: "30%" }}>Achievements</Th>
// // //                       <Th style={{ width: "30%" }}>Comments</Th>
// // //                     </tr>
// // //                   </thead>

// // //                   <tbody>
// // //                     {submittedGoals.length > 0 ? (
// // //                       <>
// // //                         {monthlyGoals.map((month) => (
// // //                           <React.Fragment key={month._id}>
// // //                             <MonthlyTr>
// // //                               <Td style={{ background: "#f0f9ff", borderLeft: "6px solid #3b82f6" }}>
// // //                                 <MonthlyBlock>
// // //                                   <MonthlyTag>Monthly Goal</MonthlyTag>
// // //                                   <div style={{ marginTop: "6px", marginBottom: "4px" }}>
// // //                                     <UnitBadge>{getGoalUnit(month)}</UnitBadge>
// // //                                   </div>
// // //                                   <GoalText>{month.goal}</GoalText>
// // //                                   <GoalMeta>{formatNiceDate(month.startDate)} — {formatNiceDate(month.deliveryDate)}</GoalMeta>
// // //                                 </MonthlyBlock>
// // //                               </Td>
// // //                               <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
// // //                               <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
// // //                             </MonthlyTr>

// // //                             {filteredWeeklies.filter((w) => w.parentMonthlyGoal === month._id).map((week) => (
// // //                               <WeeklyTr key={week._id}>
// // //                                 <Td>
// // //                                   <WeeklyGoalWrap>
// // //                                     <WeeklyTitle>{getWeekLabel(week.weeklyDeliveryDate)} Goal</WeeklyTitle>
// // //                                     <GoalText>{week.goal}</GoalText>
// // //                                     <GoalMeta>Due {formatNiceDate(week.weeklyDeliveryDate)}</GoalMeta>
// // //                                   </WeeklyGoalWrap>
// // //                                 </Td>
// // //                                 <Td>
// // //                                   {renderReadOnlyField(week.achievements, "No achievements submitted.")}
// // //                                 </Td>
// // //                                 <Td>
// // //                                   {renderReadOnlyField(week.comments, "No comments added.")}
// // //                                 </Td>
// // //                               </WeeklyTr>
// // //                             ))}
// // //                           </React.Fragment>
// // //                         ))}

// // //                         {routineGoals.map((routine) => (
// // //                           <tr key={routine._id}>
// // //                             <Td style={{ borderLeft: "6px solid #ea580c" }}>
// // //                               <MonthlyBlock>
// // //                                 <RoutineTag>Other Goal</RoutineTag>
// // //                                 <GoalText>{routine.goal}</GoalText>
// // //                                 <GoalMeta>Due {formatNiceDate(routine.deliveryDate)}</GoalMeta>
// // //                               </MonthlyBlock>
// // //                             </Td>
// // //                             <Td>
// // //                               {renderReadOnlyField(routine.achievements, "No achievements submitted.")}
// // //                             </Td>
// // //                             <Td>
// // //                               {renderReadOnlyField(routine.comments, "No comments added.")}
// // //                             </Td>
// // //                           </tr>
// // //                         ))}
// // //                       </>
// // //                     ) : (
// // //                       <tr>
// // //                         <Td colSpan="3"><NoData>No goals submitted yet for this month.</NoData></Td>
// // //                       </tr>
// // //                     )}
// // //                   </tbody>
// // //                 </GoalsTable>
// // //               </GoalsTableContainer>

// // //               {/* MOBILE LAYOUT */}
// // //               <GoalsMobileGrid>
// // //                 {submittedGoals.length > 0 ? (
// // //                   <>
// // //                     {monthlyGoals.map((month) => (
// // //                       <React.Fragment key={month._id}>
// // //                         <GoalCard>
// // //                           <GoalCardHeader><Pill>Monthly Goal</Pill></GoalCardHeader>
// // //                           <div style={{ marginBottom: "10px" }}><UnitBadge>{getGoalUnit(month)}</UnitBadge></div>
// // //                           <GoalCardTitle>{month.goal}</GoalCardTitle>
// // //                           <GoalCardMeta>{formatNiceDate(month.startDate)} — {formatNiceDate(month.deliveryDate)}</GoalCardMeta>
// // //                         </GoalCard>

// // //                         {filteredWeeklies.filter((w) => w.parentMonthlyGoal === month._id).map((week) => (
// // //                           <GoalCard key={week._id}>
// // //                             <GoalCardHeader>
// // //                               <WeeklyTitle>{getWeekLabel(week.weeklyDeliveryDate)}</WeeklyTitle>
// // //                               <Pill>Weekly</Pill>
// // //                             </GoalCardHeader>
// // //                             <GoalCardTitle>{week.goal}</GoalCardTitle>
// // //                             <GoalCardMeta>Due {formatNiceDate(week.weeklyDeliveryDate)}</GoalCardMeta>
                            
// // //                             <SmallLabel>Achievements</SmallLabel>
// // //                             {renderReadOnlyField(week.achievements, "No achievements submitted.")}
                            
// // //                             <SmallLabel>Comments</SmallLabel>
// // //                             {renderReadOnlyField(week.comments, "No comments added.")}
// // //                           </GoalCard>
// // //                         ))}
// // //                       </React.Fragment>
// // //                     ))}

// // //                     {routineGoals.map((routine) => (
// // //                       <GoalCard key={routine._id} variant="routine">
// // //                         <GoalCardHeader><Pill variant="routine">Other Goal</Pill></GoalCardHeader>
// // //                         <GoalCardTitle>{routine.goal}</GoalCardTitle>
// // //                         <GoalCardMeta>Due {formatNiceDate(routine.deliveryDate)}</GoalCardMeta>
                        
// // //                         <SmallLabel>Achievements</SmallLabel>
// // //                         {renderReadOnlyField(routine.achievements, "No achievements submitted.")}
                        
// // //                         <SmallLabel>Comments</SmallLabel>
// // //                         {renderReadOnlyField(routine.comments, "No comments added.")}
// // //                       </GoalCard>
// // //                     ))}
// // //                   </>
// // //                 ) : (
// // //                   <EmptyCard>No goals submitted yet for this month.</EmptyCard>
// // //                 )}
// // //               </GoalsMobileGrid>

// // //               <PaginationContainer>
// // //                 {weeks.map((weekLabel, i) => (
// // //                   <PageButton
// // //                     key={i} className={currentPage === i + 1 ? "active" : ""} onClick={() => setCurrentPage(i + 1)} type="button"
// // //                   >
// // //                     {weekLabel}
// // //                   </PageButton>
// // //                 ))}
// // //               </PaginationContainer>
// // //             </>
// // //           )}
// // //         </Card>
// // //       </PageWrapper>
// // //       <Footer />
// // //     </Container>
// // //   );
// // // };

// // // export default SuperAdminStaffGoals;



// // // import React, { useEffect, useMemo, useState } from "react";
// // // import styled from "styled-components";
// // // import { useParams, useNavigate } from "react-router-dom";
// // // import { FaArrowLeft } from "react-icons/fa";
// // // import NavBarSuper from "./NavBarSuper";
// // // import Footer from "./Footer";
// // // import api from "../api";

// // // /* ================= HELPERS ================= */
// // // const getCurrentMonthName = () => {
// // //   const date = new Date();
// // //   return date.toLocaleString("default", { month: "long", year: "numeric" });
// // // };

// // // // Generate a list of months for the dropdown (3 months past, 9 months future)
// // // const generateMonthOptions = () => {
// // //   const months = [];
// // //   const date = new Date();
// // //   date.setMonth(date.getMonth() - 3); 
// // //   for (let i = 0; i < 12; i++) {
// // //     months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
// // //     date.setMonth(date.getMonth() + 1);
// // //   }
// // //   return months;
// // // };

// // // // Format "April 2026" to "2026-04" for backend queries
// // // const formatToYearMonth = (periodString) => {
// // //   if (!periodString) return "";
// // //   const d = new Date(periodString);
// // //   if (isNaN(d.getTime())) return "";
// // //   const y = d.getFullYear();
// // //   const m = String(d.getMonth() + 1).padStart(2, "0");
// // //   return `${y}-${m}`;
// // // };

// // // const getWeekLabel = (dateInput) => {
// // //   if (!dateInput) return "Unknown Week";
// // //   let date;
// // //   if (dateInput instanceof Date) {
// // //     date = dateInput;
// // //   } else if (typeof dateInput === 'string') {
// // //     const datePart = dateInput.includes('T') ? dateInput.split('T')[0] : dateInput;
// // //     const parts = datePart.split('-'); 
// // //     if (parts.length !== 3) return "Invalid Date";
// // //     date = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
// // //   } else {
// // //     return "Invalid Date";
// // //   }
// // //   if (isNaN(date.getTime())) return "Invalid Date";
// // //   const sunday = new Date(date);
// // //   sunday.setDate(date.getDate() - date.getDay());
// // //   const saturday = new Date(sunday);
// // //   saturday.setDate(sunday.getDate() + 6);
// // //   const getWeekNum = (d) => {
// // //     const firstDay = new Date(d.getFullYear(), d.getMonth(), 1).getDay();
// // //     return Math.ceil((d.getDate() + firstDay) / 7);
// // //   };
// // //   if (sunday.getMonth() === saturday.getMonth()) {
// // //     return `Week ${getWeekNum(saturday)}`;
// // //   } else {
// // //     const nextMonthName = saturday.toLocaleString("default", { month: "long" });
// // //     return `Week ${getWeekNum(sunday)} / ${nextMonthName} Week ${getWeekNum(saturday)}`;
// // //   }
// // // };

// // // const formatNiceDate = (dateString) => {
// // //   if (!dateString) return "—";
// // //   const date = new Date(dateString);
// // //   if (isNaN(date.getTime())) return "Invalid date";
// // //   const month = date.toLocaleString("default", { month: "long" });
// // //   const day = date.getDate();
// // //   const year = date.getFullYear();
// // //   let suffix = "th";
// // //   if (day % 10 === 1 && day % 100 !== 11) suffix = "st";
// // //   else if (day % 10 === 2 && day % 100 !== 12) suffix = "nd";
// // //   else if (day % 10 === 3 && day % 100 !== 13) suffix = "rd";
// // //   return `${month} ${day}${suffix}, ${year}`;
// // // };

// // // const getGoalUnit = (goal) => {
// // //   let unitVal = goal.unit || goal.subDepartment || "";
// // //   if (typeof unitVal !== 'string') {
// // //     unitVal = String(unitVal);
// // //   }
// // //   return unitVal;
// // // };

// // // /* ================= PAGE LAYOUT ================= */
// // // const Container = styled.div`
// // //   display: flex;
// // //   flex-direction: column;
// // //   min-height: 100vh;
// // //   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// // // `;

// // // const PageWrapper = styled.div`
// // //   flex: 1 0 auto;
// // //   width: min(1380px, calc(100% - 32px));
// // //   margin: 90px auto 40px;

// // //   @media (max-width: 768px) {
// // //     width: min(100%, calc(100% - 20px));
// // //     margin-top: 80px;
// // //   }
// // // `;

// // // const HeaderSection = styled.div`
// // //   display: flex;
// // //   justify-content: space-between;
// // //   align-items: center;
// // //   flex-wrap: wrap;
// // //   gap: 16px;
// // //   margin-bottom: 24px;
// // // `;

// // // const BackButton = styled.button`
// // //   display: inline-flex;
// // //   align-items: center;
// // //   gap: 8px;
// // //   background: none;
// // //   border: none;
// // //   color: #1d4ed8;
// // //   font-weight: 800;
// // //   font-size: 1rem;
// // //   cursor: pointer;
// // //   transition: transform 0.2s ease;
// // //   padding: 0;

// // //   &:hover {
// // //     transform: translateX(-4px);
// // //   }
// // // `;

// // // const HeroCard = styled.div`
// // //   background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #1d4ed8 100%);
// // //   color: #fff;
// // //   border-radius: 24px;
// // //   padding: 32px;
// // //   margin-bottom: 24px;
// // //   box-shadow: 0 15px 35px rgba(15, 23, 42, 0.1);
// // //   display: flex;
// // //   justify-content: space-between;
// // //   align-items: center;
// // //   flex-wrap: wrap;
// // //   gap: 20px;
// // // `;

// // // const HeroTitle = styled.h1`
// // //   margin: 0 0 10px;
// // //   font-size: clamp(1.6rem, 1.2rem + 1.2vw, 2.4rem);
// // //   font-weight: 800;
// // // `;

// // // const HeroText = styled.p`
// // //   margin: 0;
// // //   color: rgba(255, 255, 255, 0.86);
// // //   font-size: 1.05rem;
// // //   max-width: 800px;
// // //   line-height: 1.5;
// // // `;

// // // /* ================= CARDS / TABLES ================= */
// // // const Card = styled.div`
// // //   background: rgba(255, 255, 255, 0.96);
// // //   border-radius: 28px;
// // //   padding: 24px;
// // //   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
// // //   border: 1px solid rgba(148, 163, 184, 0.16);
// // //   margin-bottom: 34px;

// // //   @media (max-width: 768px) { padding: 18px; border-radius: 22px; }
// // // `;

// // // const TitleRow = styled.div`
// // //   display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 10px;
// // // `;

// // // const SectionTitle = styled.h2`
// // //   font-size: clamp(1.15rem, 1rem + 0.6vw, 1.5rem); color: #1f2937; margin: 0; font-weight: 800;
// // // `;

// // // const GlobalMonthSelect = styled.select`
// // //   padding: 6px 16px; border-radius: 12px; border: 2px solid #bfdbfe; font-size: 1.1rem;
// // //   font-weight: 800; color: #1d4ed8; background: #eff6ff; outline: none; cursor: pointer; transition: all 0.2s;
// // //   &:focus { border-color: #3b82f6; box-shadow: 0 0 0 4px rgba(59,130,246,0.1); }
// // // `;

// // // const Subtitle = styled.p` color: #6b7280; margin: 0 0 24px; font-size: 0.98rem; line-height: 1.6; `;

// // // /* ================= BADGES ================= */
// // // const UnitBadge = styled.span`
// // //   display: inline-block; padding: 5px 10px; background: #e0f2fe; color: #0369a1; border: 1px solid #bae6fd;
// // //   border-radius: 6px; font-size: 11px; font-weight: 800; letter-spacing: 0.05em; text-transform: uppercase;
// // // `;

// // // /* ================= GOALS TABLE DESKTOP ================= */
// // // const GoalsTableContainer = styled.div`
// // //   border-radius: 18px; border: 1px solid #e2e8f0; background: white; width: 100%; overflow: hidden;
// // //   @media (max-width: 900px) { display: none; }
// // // `;

// // // const GoalsTable = styled.table` width: 100%; border-collapse: collapse; background: white; table-layout: fixed; `;
// // // const Th = styled.th` background: #f8fafc; padding: 18px 20px; text-align: left; font-weight: 700; color: #1e293b; border-bottom: 2px solid #e2e8f0; font-size: 14px; `;
// // // const Td = styled.td` padding: 18px 20px; border-bottom: 1px solid #f1f5f9; color: #1f2937; font-size: 15px; vertical-align: top; white-space: normal; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; max-width: 0; `;
// // // const MonthlyTr = styled.tr` background: #f0f9ff; `;
// // // const WeeklyTr = styled.tr` background: #fff; `;
// // // const MonthlyBlock = styled.div` padding: 8px 0; `;
// // // const MonthlyTag = styled.div` color: #1e40af; font-size: 13px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; `;
// // // const RoutineTag = styled(MonthlyTag)` color: #ea580c; `;
// // // const GoalText = styled.div` margin-top: 10px; font-weight: 700; font-size: 16px; line-height: 1.5; color: #0f172a; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; white-space: normal; width: 100%; `;
// // // const GoalMeta = styled.div` margin-top: 6px; color: #2563eb; font-size: 14px; font-weight: 700; line-height: 1.5; `;
// // // const WeeklyGoalWrap = styled.div` display: grid; gap: 6px; min-width: 0; position: relative; padding-left: 16px; border-left: 2px solid #cbd5f5; &::before { content: ""; position: absolute; left: -6px; top: 16px; width: 10px; height: 2px; background: #3b82f6; } `;
// // // const WeeklyTitle = styled.div` font-weight: 800; font-size: 12px; color: #1d4ed8; text-transform: uppercase; letter-spacing: 0.04em; display: flex; align-items: center; gap: 6px; &::before { content: "→"; font-size: 14px; color: #3b82f6; } `;
// // // const NoData = styled.p` text-align: center; color: #6b7280; font-style: italic; padding: 60px 20px; font-size: 15.5px; `;

// // // const ReadOnlyText = styled.div`
// // //   width: 100%; min-height: 60px; padding: 14px; font-size: 14px; line-height: 1.6;
// // //   background: #f8fafc; color: #334155; border-radius: 12px; border: 1px solid #e2e8f0;
// // //   white-space: pre-wrap;
// // // `;

// // // const EmptyStateText = styled(ReadOnlyText)`
// // //   color: #94a3b8; font-style: italic; background: #fdfdfd; border: 1px dashed #cbd5e1;
// // // `;

// // // /* ================= RESPONSIVE GOAL CARDS ================= */
// // // const GoalsMobileGrid = styled.div` display: none; @media (max-width: 900px) { display: grid; gap: 16px; } `;
// // // const GoalCard = styled.div` background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%); border: 1px solid rgba(148, 163, 184, 0.18); border-left: 5px solid ${({ variant }) => (variant === "routine" ? "#ea580c" : "#3b82f6")}; border-radius: 22px; padding: 18px; box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06); position: relative; `;
// // // const GoalCardHeader = styled.div` display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; flex-wrap: wrap; margin-bottom: 14px; `;
// // // const Pill = styled.div` display: inline-flex; align-items: center; padding: 8px 12px; border-radius: 999px; font-size: 12px; font-weight: 800; letter-spacing: 0.04em; text-transform: uppercase; background: ${({ variant }) => variant === "routine" ? "rgba(234, 88, 12, 0.12)" : "rgba(37,99,235,0.12)"}; color: ${({ variant }) => (variant === "routine" ? "#ea580c" : "#1d4ed8")}; `;
// // // const GoalCardTitle = styled.div` font-size: 1rem; font-weight: 800; line-height: 1.5; color: #0f172a; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; white-space: normal; `;
// // // const GoalCardMeta = styled.div` margin-top: 6px; font-size: 14px; color: #64748b; line-height: 1.5; `;
// // // const SmallLabel = styled.div` font-size: 12px; font-weight: 800; color: #64748b; margin: 14px 0 6px; text-transform: uppercase; letter-spacing: 0.04em; `;
// // // const EmptyCard = styled.div` padding: 28px 20px; text-align: center; border-radius: 18px; background: #f8fafc; border: 1px dashed #cbd5e1; color: #64748b; `;

// // // /* ================= PAGINATION ================= */
// // // const PaginationContainer = styled.div` display: flex; justify-content: center; align-items: center; gap: 12px; margin-top: 28px; flex-wrap: wrap; `;
// // // const PageButton = styled.button` padding: 10px 18px; border: 1px solid #cbd5e1; background: white; border-radius: 9999px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; &:hover:not(:disabled) { background: #f1f5f9; transform: translateY(-1px); color: #1e40af; } &:disabled { opacity: 0.5; cursor: not-allowed; } &.active { background: #1e40af; color: white; border-color: #1e40af; } `;

// // // /* ================= STATES ================= */
// // // const StateBox = styled.div`
// // //   text-align: center; padding: 50px 20px; border-radius: 18px;
// // //   background: ${({ type }) => type === 'error' ? '#fef2f2' : '#ffffff'};
// // //   color: ${({ type }) => type === 'error' ? '#dc2626' : '#64748b'};
// // //   border: 1px solid ${({ type }) => type === 'error' ? '#fecaca' : '#e2e8f0'};
// // //   font-size: 1rem;
// // // `;

// // // const Spinner = styled.div`
// // //   width: 40px; height: 40px; margin: 0 auto 16px; border-radius: 50%;
// // //   border: 4px solid #e0ecff; border-top-color: #1d4ed8; animation: spin 0.8s linear infinite;
// // //   @keyframes spin { to { transform: rotate(360deg); } }
// // // `;

// // // /* ================= COMPONENT ================= */
// // // const SuperAdminStaffGoals = ({ user }) => {
// // //   const { userId } = useParams();
// // //   const navigate = useNavigate();
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);
// // //   const [staffInfo, setStaffInfo] = useState(null);

// // //   const availableMonths = useMemo(() => generateMonthOptions(), []);
  
// // //   // Use a different storage key so it doesn't conflict with their own dashboard state
// // //   const [selectedMonth, setSelectedMonth] = useState(
// // //     localStorage.getItem("superAdminViewMonth") || getCurrentMonthName()
// // //   );

// // //   const [submittedGoals, setSubmittedGoals] = useState([]);
// // //   const [currentPage, setCurrentPage] = useState(1);

// // //   useEffect(() => {
// // //     localStorage.setItem("superAdminViewMonth", selectedMonth);
// // //   }, [selectedMonth]);

  
// // //   useEffect(() => {
// // //     const fetchStaffGoals = async () => {
// // //       try {
// // //         setLoading(true);
// // //         setError(null);
        
// // //         // We need to fetch the goals for this specific user. 
// // //         const targetMonthParam = formatToYearMonth(selectedMonth);
        
// // //         const res = await api.get(`/goals/admin/user-month/${userId}?targetMonth=${targetMonthParam}`);
        
// // //         setSubmittedGoals(res.data.data || []);
// // //         if (res.data.staff) setStaffInfo(res.data.staff);
        
// // //       } catch (err) {
// // //         console.error(err);
// // //         setError(err.response?.data?.message || 'Failed to fetch staff goals');
// // //         setSubmittedGoals([]);
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     };

// // //     if (userId) {
// // //       fetchStaffGoals();
// // //     }
// // //   }, [userId, selectedMonth]);

// // //   const monthlyGoals = submittedGoals.filter((g) => g.type === "monthly");
// // //   const weeklyGoals = submittedGoals.filter((g) => g.type === "weekly");
// // //   const routineGoals = submittedGoals.filter((g) => g.type === "routine");

// // //   const descendingWeeklyGoals = [...weeklyGoals].sort((a, b) => new Date(b.weeklyDeliveryDate).getTime() - new Date(a.weeklyDeliveryDate).getTime());
// // //   const weeks = [...new Set(descendingWeeklyGoals.map((w) => getWeekLabel(w.weeklyDeliveryDate)))];
// // //   const maxPages = Math.max(weeks.length, 1);
// // //   const displayWeek = weeks[currentPage - 1] || getWeekLabel(new Date());
  
// // //   const filteredWeeklies = weeklyGoals.filter((w) => getWeekLabel(w.weeklyDeliveryDate) === displayWeek);

// // //   const renderReadOnlyField = (content, placeholder) => {
// // //     if (!content || !content.trim()) {
// // //       return <EmptyStateText>{placeholder}</EmptyStateText>;
// // //     }
// // //     return <ReadOnlyText>{content}</ReadOnlyText>;
// // //   };

// // //   return (
// // //     <Container>
// // //       <NavBarSuper user={user} />

// // //       <PageWrapper>
// // //         <HeaderSection>
// // //           <BackButton onClick={() => navigate('/super-admin/dashboard')}>
// // //             <FaArrowLeft /> Back to Directory
// // //           </BackButton>
// // //         </HeaderSection>

// // //         <HeroCard>
// // //           <div>
// // //             <HeroTitle>Staff Goal Review</HeroTitle>
// // //             <HeroText>
// // //               Reviewing the submitted goals, achievements, and comments for <strong>{staffInfo?.firstName || 'this staff member'}</strong>.
// // //             </HeroText>
// // //           </div>
// // //         </HeroCard>

// // //         <Card>
// // //           <TitleRow>
// // //             <SectionTitle>Viewing Goals for</SectionTitle>
// // //             <GlobalMonthSelect value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
// // //               {availableMonths.map(m => (
// // //                 <option key={m} value={m}>{m}</option>
// // //               ))}
// // //             </GlobalMonthSelect>
// // //           </TitleRow>

// // //           <Subtitle>
// // //             This view is read-only. To score these achievements, return to the dashboard and open their Appraisal Submission.
// // //           </Subtitle>

// // //           {loading ? (
// // //             <StateBox>
// // //               <Spinner />
// // //               Loading staff records...
// // //             </StateBox>
// // //           ) : error ? (
// // //             <StateBox type="error">{error}</StateBox>
// // //           ) : (
// // //             <>
// // //               {/* DESKTOP TABLE */}
// // //               <GoalsTableContainer>
// // //                 <GoalsTable>
// // //                   <thead>
// // //                     <tr>
// // //                       <Th style={{ width: "40%" }}>Goals</Th>
// // //                       <Th style={{ width: "30%" }}>Achievements</Th>
// // //                       <Th style={{ width: "30%" }}>Comments</Th>
// // //                     </tr>
// // //                   </thead>

// // //                   <tbody>
// // //                     {submittedGoals.length > 0 ? (
// // //                       <>
// // //                         {monthlyGoals.map((month) => (
// // //                           <React.Fragment key={month._id}>
// // //                             <MonthlyTr>
// // //                               <Td style={{ background: "#f0f9ff", borderLeft: "6px solid #3b82f6" }}>
// // //                                 <MonthlyBlock>
// // //                                   <MonthlyTag>Monthly Goal</MonthlyTag>
// // //                                   <div style={{ marginTop: "6px", marginBottom: "4px" }}>
// // //                                     <UnitBadge>{getGoalUnit(month)}</UnitBadge>
// // //                                   </div>
// // //                                   <GoalText>{month.goal}</GoalText>
// // //                                   <GoalMeta>{formatNiceDate(month.startDate)} — {formatNiceDate(month.deliveryDate)}</GoalMeta>
// // //                                 </MonthlyBlock>
// // //                               </Td>
// // //                               <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
// // //                               <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
// // //                             </MonthlyTr>

// // //                             {filteredWeeklies.filter((w) => w.parentMonthlyGoal === month._id).map((week) => (
// // //                               <WeeklyTr key={week._id}>
// // //                                 <Td>
// // //                                   <WeeklyGoalWrap>
// // //                                     <WeeklyTitle>{getWeekLabel(week.weeklyDeliveryDate)} Goal</WeeklyTitle>
// // //                                     <GoalText>{week.goal}</GoalText>
// // //                                     <GoalMeta>Due {formatNiceDate(week.weeklyDeliveryDate)}</GoalMeta>
// // //                                   </WeeklyGoalWrap>
// // //                                 </Td>
// // //                                 <Td>
// // //                                   {renderReadOnlyField(week.achievements, "No achievements submitted.")}
// // //                                 </Td>
// // //                                 <Td>
// // //                                   {renderReadOnlyField(week.comments, "No comments added.")}
// // //                                 </Td>
// // //                               </WeeklyTr>
// // //                             ))}
// // //                           </React.Fragment>
// // //                         ))}

// // //                         {routineGoals.map((routine) => (
// // //                           <tr key={routine._id}>
// // //                             <Td style={{ borderLeft: "6px solid #ea580c" }}>
// // //                               <MonthlyBlock>
// // //                                 <RoutineTag>Other Goal</RoutineTag>
// // //                                 <GoalText>{routine.goal}</GoalText>
// // //                                 <GoalMeta>Due {formatNiceDate(routine.deliveryDate)}</GoalMeta>
// // //                               </MonthlyBlock>
// // //                             </Td>
// // //                             <Td>
// // //                               {renderReadOnlyField(routine.achievements, "No achievements submitted.")}
// // //                             </Td>
// // //                             <Td>
// // //                               {renderReadOnlyField(routine.comments, "No comments added.")}
// // //                             </Td>
// // //                           </tr>
// // //                         ))}
// // //                       </>
// // //                     ) : (
// // //                       <tr>
// // //                         <Td colSpan="3"><NoData>No goals submitted yet for this month.</NoData></Td>
// // //                       </tr>
// // //                     )}
// // //                   </tbody>
// // //                 </GoalsTable>
// // //               </GoalsTableContainer>

// // //               {/* MOBILE LAYOUT */}
// // //               <GoalsMobileGrid>
// // //                 {submittedGoals.length > 0 ? (
// // //                   <>
// // //                     {monthlyGoals.map((month) => (
// // //                       <React.Fragment key={month._id}>
// // //                         <GoalCard>
// // //                           <GoalCardHeader><Pill>Monthly Goal</Pill></GoalCardHeader>
// // //                           <div style={{ marginBottom: "10px" }}><UnitBadge>{getGoalUnit(month)}</UnitBadge></div>
// // //                           <GoalCardTitle>{month.goal}</GoalCardTitle>
// // //                           <GoalCardMeta>{formatNiceDate(month.startDate)} — {formatNiceDate(month.deliveryDate)}</GoalCardMeta>
// // //                         </GoalCard>

// // //                         {filteredWeeklies.filter((w) => w.parentMonthlyGoal === month._id).map((week) => (
// // //                           <GoalCard key={week._id}>
// // //                             <GoalCardHeader>
// // //                               <WeeklyTitle>{getWeekLabel(week.weeklyDeliveryDate)}</WeeklyTitle>
// // //                               <Pill>Weekly</Pill>
// // //                             </GoalCardHeader>
// // //                             <GoalCardTitle>{week.goal}</GoalCardTitle>
// // //                             <GoalCardMeta>Due {formatNiceDate(week.weeklyDeliveryDate)}</GoalCardMeta>
                            
// // //                             <SmallLabel>Achievements</SmallLabel>
// // //                             {renderReadOnlyField(week.achievements, "No achievements submitted.")}
                            
// // //                             <SmallLabel>Comments</SmallLabel>
// // //                             {renderReadOnlyField(week.comments, "No comments added.")}
// // //                           </GoalCard>
// // //                         ))}
// // //                       </React.Fragment>
// // //                     ))}

// // //                     {routineGoals.map((routine) => (
// // //                       <GoalCard key={routine._id} variant="routine">
// // //                         <GoalCardHeader><Pill variant="routine">Other Goal</Pill></GoalCardHeader>
// // //                         <GoalCardTitle>{routine.goal}</GoalCardTitle>
// // //                         <GoalCardMeta>Due {formatNiceDate(routine.deliveryDate)}</GoalCardMeta>
                        
// // //                         <SmallLabel>Achievements</SmallLabel>
// // //                         {renderReadOnlyField(routine.achievements, "No achievements submitted.")}
                        
// // //                         <SmallLabel>Comments</SmallLabel>
// // //                         {renderReadOnlyField(routine.comments, "No comments added.")}
// // //                       </GoalCard>
// // //                     ))}
// // //                   </>
// // //                 ) : (
// // //                   <EmptyCard>No goals submitted yet for this month.</EmptyCard>
// // //                 )}
// // //               </GoalsMobileGrid>

// // //               <PaginationContainer>
// // //                 {weeks.map((weekLabel, i) => (
// // //                   <PageButton
// // //                     key={i} className={currentPage === i + 1 ? "active" : ""} onClick={() => setCurrentPage(i + 1)} type="button"
// // //                   >
// // //                     {weekLabel}
// // //                   </PageButton>
// // //                 ))}
// // //               </PaginationContainer>
// // //             </>
// // //           )}
// // //         </Card>
// // //       </PageWrapper>
// // //       <Footer />
// // //     </Container>
// // //   );
// // // };

// // // export default SuperAdminStaffGoals;





// // // import React, { useEffect, useMemo, useState } from "react";
// // // import styled from "styled-components";
// // // import { useParams, useNavigate } from "react-router-dom";
// // // import { FaArrowLeft } from "react-icons/fa";
// // // import NavBarSuper from "./NavBarSuper";
// // // import Footer from "./Footer";
// // // import api from "../api";

// // // /* ================= HELPERS ================= */
// // // const getCurrentMonthName = () => {
// // //   const date = new Date();
// // //   return date.toLocaleString("default", { month: "long", year: "numeric" });
// // // };

// // // // Generate a list of months for the dropdown (3 months past, 9 months future)
// // // const generateMonthOptions = () => {
// // //   const months = [];
// // //   const date = new Date();
// // //   date.setMonth(date.getMonth() - 3); 
// // //   for (let i = 0; i < 12; i++) {
// // //     months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
// // //     date.setMonth(date.getMonth() + 1);
// // //   }
// // //   return months;
// // // };

// // // // Format "April 2026" to "2026-04" for backend queries
// // // const formatToYearMonth = (periodString) => {
// // //   if (!periodString) return "";
// // //   const d = new Date(periodString);
// // //   if (isNaN(d.getTime())) return "";
// // //   const y = d.getFullYear();
// // //   const m = String(d.getMonth() + 1).padStart(2, "0");
// // //   return `${y}-${m}`;
// // // };

// // // const getWeekLabel = (dateInput) => {
// // //   if (!dateInput) return "Unknown Week";
// // //   let date;
// // //   if (dateInput instanceof Date) {
// // //     date = dateInput;
// // //   } else if (typeof dateInput === 'string') {
// // //     const datePart = dateInput.includes('T') ? dateInput.split('T')[0] : dateInput;
// // //     const parts = datePart.split('-'); 
// // //     if (parts.length !== 3) return "Invalid Date";
// // //     date = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
// // //   } else {
// // //     return "Invalid Date";
// // //   }
// // //   if (isNaN(date.getTime())) return "Invalid Date";
// // //   const sunday = new Date(date);
// // //   sunday.setDate(date.getDate() - date.getDay());
// // //   const saturday = new Date(sunday);
// // //   saturday.setDate(sunday.getDate() + 6);
// // //   const getWeekNum = (d) => {
// // //     const firstDay = new Date(d.getFullYear(), d.getMonth(), 1).getDay();
// // //     return Math.ceil((d.getDate() + firstDay) / 7);
// // //   };
// // //   if (sunday.getMonth() === saturday.getMonth()) {
// // //     return `Week ${getWeekNum(saturday)}`;
// // //   } else {
// // //     const nextMonthName = saturday.toLocaleString("default", { month: "long" });
// // //     return `Week ${getWeekNum(sunday)} / ${nextMonthName} Week ${getWeekNum(saturday)}`;
// // //   }
// // // };

// // // const formatNiceDate = (dateString) => {
// // //   if (!dateString) return "—";
// // //   const date = new Date(dateString);
// // //   if (isNaN(date.getTime())) return "Invalid date";
// // //   const month = date.toLocaleString("default", { month: "long" });
// // //   const day = date.getDate();
// // //   const year = date.getFullYear();
// // //   let suffix = "th";
// // //   if (day % 10 === 1 && day % 100 !== 11) suffix = "st";
// // //   else if (day % 10 === 2 && day % 100 !== 12) suffix = "nd";
// // //   else if (day % 10 === 3 && day % 100 !== 13) suffix = "rd";
// // //   return `${month} ${day}${suffix}, ${year}`;
// // // };

// // // const getGoalUnit = (goal) => {
// // //   let unitVal = goal.unit || goal.subDepartment || "";
// // //   if (typeof unitVal !== 'string') {
// // //     unitVal = String(unitVal);
// // //   }
// // //   return unitVal;
// // // };

// // // /* ================= PAGE LAYOUT ================= */
// // // const Container = styled.div`
// // //   display: flex;
// // //   flex-direction: column;
// // //   min-height: 100vh;
// // //   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// // // `;

// // // const PageWrapper = styled.div`
// // //   flex: 1 0 auto;
// // //   width: min(1380px, calc(100% - 32px));
// // //   margin: 90px auto 40px;

// // //   @media (max-width: 768px) {
// // //     width: min(100%, calc(100% - 20px));
// // //     margin-top: 80px;
// // //   }
// // // `;

// // // const HeaderSection = styled.div`
// // //   display: flex;
// // //   justify-content: space-between;
// // //   align-items: center;
// // //   flex-wrap: wrap;
// // //   gap: 16px;
// // //   margin-bottom: 24px;
// // // `;

// // // const BackButton = styled.button`
// // //   display: inline-flex;
// // //   align-items: center;
// // //   gap: 8px;
// // //   background: none;
// // //   border: none;
// // //   color: #1d4ed8;
// // //   font-weight: 800;
// // //   font-size: 1rem;
// // //   cursor: pointer;
// // //   transition: transform 0.2s ease;
// // //   padding: 0;

// // //   &:hover {
// // //     transform: translateX(-4px);
// // //   }
// // // `;

// // // const HeroCard = styled.div`
// // //   background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #1d4ed8 100%);
// // //   color: #fff;
// // //   border-radius: 24px;
// // //   padding: 32px;
// // //   margin-bottom: 24px;
// // //   box-shadow: 0 15px 35px rgba(15, 23, 42, 0.1);
// // //   display: flex;
// // //   justify-content: space-between;
// // //   align-items: center;
// // //   flex-wrap: wrap;
// // //   gap: 20px;
// // // `;

// // // const HeroTitle = styled.h1`
// // //   margin: 0 0 10px;
// // //   font-size: clamp(1.6rem, 1.2rem + 1.2vw, 2.4rem);
// // //   font-weight: 800;
// // // `;

// // // const HeroText = styled.p`
// // //   margin: 0;
// // //   color: rgba(255, 255, 255, 0.86);
// // //   font-size: 1.05rem;
// // //   max-width: 800px;
// // //   line-height: 1.5;
// // // `;

// // // /* ================= CARDS / TABLES ================= */
// // // const Card = styled.div`
// // //   background: rgba(255, 255, 255, 0.96);
// // //   border-radius: 28px;
// // //   padding: 24px;
// // //   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
// // //   border: 1px solid rgba(148, 163, 184, 0.16);
// // //   margin-bottom: 34px;

// // //   @media (max-width: 768px) { padding: 18px; border-radius: 22px; }
// // // `;

// // // const TitleRow = styled.div`
// // //   display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 10px;
// // // `;

// // // const SectionTitle = styled.h2`
// // //   font-size: clamp(1.15rem, 1rem + 0.6vw, 1.5rem); color: #1f2937; margin: 0; font-weight: 800;
// // // `;

// // // const GlobalMonthSelect = styled.select`
// // //   padding: 6px 16px; border-radius: 12px; border: 2px solid #bfdbfe; font-size: 1.1rem;
// // //   font-weight: 800; color: #1d4ed8; background: #eff6ff; outline: none; cursor: pointer; transition: all 0.2s;
// // //   &:focus { border-color: #3b82f6; box-shadow: 0 0 0 4px rgba(59,130,246,0.1); }
// // // `;

// // // const Subtitle = styled.p` color: #6b7280; margin: 0 0 24px; font-size: 0.98rem; line-height: 1.6; `;

// // // /* ================= BADGES ================= */
// // // const UnitBadge = styled.span`
// // //   display: inline-block; padding: 5px 10px; background: #e0f2fe; color: #0369a1; border: 1px solid #bae6fd;
// // //   border-radius: 6px; font-size: 11px; font-weight: 800; letter-spacing: 0.05em; text-transform: uppercase;
// // // `;

// // // /* ================= GOALS TABLE DESKTOP ================= */
// // // const GoalsTableContainer = styled.div`
// // //   border-radius: 18px; border: 1px solid #e2e8f0; background: white; width: 100%; overflow: hidden;
// // //   @media (max-width: 900px) { display: none; }
// // // `;

// // // const GoalsTable = styled.table` width: 100%; border-collapse: collapse; background: white; table-layout: fixed; `;
// // // const Th = styled.th` background: #f8fafc; padding: 18px 20px; text-align: left; font-weight: 700; color: #1e293b; border-bottom: 2px solid #e2e8f0; font-size: 14px; `;
// // // const Td = styled.td` padding: 18px 20px; border-bottom: 1px solid #f1f5f9; color: #1f2937; font-size: 15px; vertical-align: top; white-space: normal; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; max-width: 0; `;
// // // const MonthlyTr = styled.tr` background: #f0f9ff; `;
// // // const WeeklyTr = styled.tr` background: #fff; `;
// // // const MonthlyBlock = styled.div` padding: 8px 0; `;
// // // const MonthlyTag = styled.div` color: #1e40af; font-size: 13px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; `;
// // // const RoutineTag = styled(MonthlyTag)` color: #ea580c; `;
// // // const GoalText = styled.div` margin-top: 10px; font-weight: 700; font-size: 16px; line-height: 1.5; color: #0f172a; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; white-space: normal; width: 100%; `;
// // // const GoalMeta = styled.div` margin-top: 6px; color: #2563eb; font-size: 14px; font-weight: 700; line-height: 1.5; `;
// // // const WeeklyGoalWrap = styled.div` display: grid; gap: 6px; min-width: 0; position: relative; padding-left: 16px; border-left: 2px solid #cbd5f5; &::before { content: ""; position: absolute; left: -6px; top: 16px; width: 10px; height: 2px; background: #3b82f6; } `;
// // // const WeeklyTitle = styled.div` font-weight: 800; font-size: 12px; color: #1d4ed8; text-transform: uppercase; letter-spacing: 0.04em; display: flex; align-items: center; gap: 6px; &::before { content: "→"; font-size: 14px; color: #3b82f6; } `;
// // // const NoData = styled.p` text-align: center; color: #6b7280; font-style: italic; padding: 60px 20px; font-size: 15.5px; `;

// // // const ReadOnlyText = styled.div`
// // //   width: 100%; min-height: 60px; padding: 14px; font-size: 14px; line-height: 1.6;
// // //   background: #f8fafc; color: #334155; border-radius: 12px; border: 1px solid #e2e8f0;
// // //   white-space: pre-wrap;
// // // `;

// // // const EmptyStateText = styled(ReadOnlyText)`
// // //   color: #94a3b8; font-style: italic; background: #fdfdfd; border: 1px dashed #cbd5e1;
// // // `;

// // // /* 🔥 NEW: Interactive Feedback Styles */
// // // const FieldTextarea = styled.textarea` 
// // //   width: 100%; min-height: 80px; border: 1px solid #fcd34d; border-radius: 10px; padding: 12px; 
// // //   font-size: 14px; resize: vertical; box-sizing: border-box; transition: all 0.2s;
// // //   background: #fffbeb; color: #1f2937; margin-bottom: 8px;
// // //   &:focus { border-color: #d97706; box-shadow: 0 0 0 4px rgba(217, 119, 6, 0.12); outline: none; } 
// // // `;

// // // const SendButton = styled.button` 
// // //   background: #d97706; color: white; border: none; padding: 10px 16px; border-radius: 8px; 
// // //   font-weight: 700; cursor: pointer; font-size: 13px; width: 100%; transition: all 0.2s;
// // //   &:disabled { opacity: 0.6; cursor: not-allowed; } 
// // //   &:hover:not(:disabled) { background: #b45309; } 
// // // `;

// // // const InlineMessage = styled.div`
// // //   font-size: 12px;
// // //   font-weight: 700;
// // //   padding: 8px 10px;
// // //   border-radius: 8px;
// // //   margin-bottom: 8px;
// // //   text-align: center;
// // //   background: ${({ type }) => type === 'success' ? 'rgba(22, 163, 74, 0.1)' : 'rgba(220, 38, 38, 0.1)'};
// // //   color: ${({ type }) => type === 'success' ? '#16a34a' : '#dc2626'};
// // //   border: 1px solid ${({ type }) => type === 'success' ? 'rgba(22, 163, 74, 0.2)' : 'rgba(220, 38, 38, 0.2)'};
// // // `;

// // // /* ================= RESPONSIVE GOAL CARDS ================= */
// // // const GoalsMobileGrid = styled.div` display: none; @media (max-width: 900px) { display: grid; gap: 16px; } `;
// // // const GoalCard = styled.div` background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%); border: 1px solid rgba(148, 163, 184, 0.18); border-left: 5px solid ${({ variant }) => (variant === "routine" ? "#ea580c" : "#3b82f6")}; border-radius: 22px; padding: 18px; box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06); position: relative; `;
// // // const GoalCardHeader = styled.div` display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; flex-wrap: wrap; margin-bottom: 14px; `;
// // // const Pill = styled.div` display: inline-flex; align-items: center; padding: 8px 12px; border-radius: 999px; font-size: 12px; font-weight: 800; letter-spacing: 0.04em; text-transform: uppercase; background: ${({ variant }) => variant === "routine" ? "rgba(234, 88, 12, 0.12)" : "rgba(37,99,235,0.12)"}; color: ${({ variant }) => (variant === "routine" ? "#ea580c" : "#1d4ed8")}; `;
// // // const GoalCardTitle = styled.div` font-size: 1rem; font-weight: 800; line-height: 1.5; color: #0f172a; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; white-space: normal; `;
// // // const GoalCardMeta = styled.div` margin-top: 6px; font-size: 14px; color: #64748b; line-height: 1.5; `;
// // // const SmallLabel = styled.div` font-size: 12px; font-weight: 800; color: #64748b; margin: 14px 0 6px; text-transform: uppercase; letter-spacing: 0.04em; `;
// // // const EmptyCard = styled.div` padding: 28px 20px; text-align: center; border-radius: 18px; background: #f8fafc; border: 1px dashed #cbd5e1; color: #64748b; `;

// // // /* ================= PAGINATION ================= */
// // // const PaginationContainer = styled.div` display: flex; justify-content: center; align-items: center; gap: 12px; margin-top: 28px; flex-wrap: wrap; `;
// // // const PageButton = styled.button` padding: 10px 18px; border: 1px solid #cbd5e1; background: white; border-radius: 9999px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; &:hover:not(:disabled) { background: #f1f5f9; transform: translateY(-1px); color: #1e40af; } &:disabled { opacity: 0.5; cursor: not-allowed; } &.active { background: #1e40af; color: white; border-color: #1e40af; } `;

// // // /* ================= STATES ================= */
// // // const StateBox = styled.div`
// // //   text-align: center; padding: 50px 20px; border-radius: 18px;
// // //   background: ${({ type }) => type === 'error' ? '#fef2f2' : '#ffffff'};
// // //   color: ${({ type }) => type === 'error' ? '#dc2626' : '#64748b'};
// // //   border: 1px solid ${({ type }) => type === 'error' ? '#fecaca' : '#e2e8f0'};
// // //   font-size: 1rem;
// // // `;

// // // const Spinner = styled.div`
// // //   width: 40px; height: 40px; margin: 0 auto 16px; border-radius: 50%;
// // //   border: 4px solid #e0ecff; border-top-color: #1d4ed8; animation: spin 0.8s linear infinite;
// // //   @keyframes spin { to { transform: rotate(360deg); } }
// // // `;

// // // /* ================= COMPONENT ================= */
// // // const SuperAdminStaffGoals = ({ user }) => {
// // //   const { userId } = useParams();
// // //   const navigate = useNavigate();
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);
// // //   const [staffInfo, setStaffInfo] = useState(null);

// // //   // 🔥 NEW STATE FOR FEEDBACK INLINE MESSAGES
// // //   const [editValues, setEditValues] = useState({});
// // //   const [updatingId, setUpdatingId] = useState(null);
// // //   const [feedbackStatus, setFeedbackStatus] = useState({}); // Stores { type: 'success'|'error', text: '' }

// // //   const availableMonths = useMemo(() => generateMonthOptions(), []);
  
// // //   // Use a different storage key so it doesn't conflict with their own dashboard state
// // //   const [selectedMonth, setSelectedMonth] = useState(
// // //     localStorage.getItem("superAdminViewMonth") || getCurrentMonthName()
// // //   );

// // //   const [submittedGoals, setSubmittedGoals] = useState([]);
// // //   const [currentPage, setCurrentPage] = useState(1);

// // //   useEffect(() => {
// // //     localStorage.setItem("superAdminViewMonth", selectedMonth);
// // //   }, [selectedMonth]);

  
// // //   useEffect(() => {
// // //     const fetchStaffGoals = async () => {
// // //       try {
// // //         setLoading(true);
// // //         setError(null);
        
// // //         // We need to fetch the goals for this specific user. 
// // //         const targetMonthParam = formatToYearMonth(selectedMonth);
        
// // //         const res = await api.get(`/goals/admin/user-month/${userId}?targetMonth=${targetMonthParam}`);
        
// // //         setSubmittedGoals(res.data.data || []);
// // //         if (res.data.staff) setStaffInfo(res.data.staff);
        
// // //       } catch (err) {
// // //         console.error(err);
// // //         setError(err.response?.data?.message || 'Failed to fetch staff goals');
// // //         setSubmittedGoals([]);
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     };

// // //     if (userId) {
// // //       fetchStaffGoals();
// // //     }
// // //   }, [userId, selectedMonth]);

// // //   const monthlyGoals = submittedGoals.filter((g) => g.type === "monthly");
// // //   const weeklyGoals = submittedGoals.filter((g) => g.type === "weekly");
// // //   const routineGoals = submittedGoals.filter((g) => g.type === "routine");

// // //   const descendingWeeklyGoals = [...weeklyGoals].sort((a, b) => new Date(b.weeklyDeliveryDate).getTime() - new Date(a.weeklyDeliveryDate).getTime());
// // //   const weeks = [...new Set(descendingWeeklyGoals.map((w) => getWeekLabel(w.weeklyDeliveryDate)))];
// // //   const maxPages = Math.max(weeks.length, 1);
// // //   const displayWeek = weeks[currentPage - 1] || getWeekLabel(new Date());
  
// // //   const filteredWeeklies = weeklyGoals.filter((w) => getWeekLabel(w.weeklyDeliveryDate) === displayWeek);

// // //   const renderReadOnlyField = (content, placeholder) => {
// // //     if (!content || !content.trim()) {
// // //       return <EmptyStateText>{placeholder}</EmptyStateText>;
// // //     }
// // //     return <ReadOnlyText>{content}</ReadOnlyText>;
// // //   };

// // //   // 🔥 HANDLERS FOR INLINE FEEDBACK
// // //   const handleEditChange = (id, field, value) => {
// // //     setEditValues((prev) => ({
// // //       ...prev,
// // //       [`${id}_${field}`]: value,
// // //     }));
// // //   };

// // //   const saveFeedback = async (goalId) => {
// // //     const supervisorComments = editValues[`${goalId}_sup`] !== undefined 
// // //       ? editValues[`${goalId}_sup`] 
// // //       : submittedGoals.find(g => g._id === goalId)?.supervisorComments || "";

// // //     setUpdatingId(goalId);
    
// // //     // Clear any previous message for this goal
// // //     setFeedbackStatus((prev) => ({ ...prev, [goalId]: null }));

// // //     try {
// // //       await api.put(`/goals/achievement/${goalId}`, { supervisorComments });
      
// // //       // Show success inline message
// // //       setFeedbackStatus((prev) => ({
// // //         ...prev,
// // //         [goalId]: { type: "success", text: "Sent to staff!" }
// // //       }));

// // //       // Hide success message after 3 seconds
// // //       setTimeout(() => {
// // //         setFeedbackStatus((prev) => ({ ...prev, [goalId]: null }));
// // //       }, 3000);

// // //     } catch (err) {
// // //       console.error(err);
// // //       // Show error inline message
// // //       setFeedbackStatus((prev) => ({
// // //         ...prev,
// // //         [goalId]: { type: "error", text: "Failed to send" }
// // //       }));
// // //     } finally {
// // //       setUpdatingId(null);
// // //     }
// // //   };


// // //   return (
// // //     <Container>
// // //       <NavBarSuper user={user} />

// // //       <PageWrapper>
// // //         <HeaderSection>
// // //           <BackButton onClick={() => navigate('/super-admin/dashboard')}>
// // //             <FaArrowLeft /> Back to Directory
// // //           </BackButton>
// // //         </HeaderSection>

// // //         <HeroCard>
// // //           <div>
// // //             <HeroTitle>Staff Goal Review</HeroTitle>
// // //             <HeroText>
// // //               Reviewing the submitted goals, achievements, and comments for <strong>{staffInfo?.firstName || 'this staff member'}</strong>. Send feedback directly to their dashboard.
// // //             </HeroText>
// // //           </div>
// // //         </HeroCard>

// // //         <Card>
// // //           <TitleRow>
// // //             <SectionTitle>Viewing Goals for</SectionTitle>
// // //             <GlobalMonthSelect value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
// // //               {availableMonths.map(m => (
// // //                 <option key={m} value={m}>{m}</option>
// // //               ))}
// // //             </GlobalMonthSelect>
// // //           </TitleRow>

// // //           <Subtitle>
// // //             Read their achievements and send weekly/routine feedback directly below. To formally score these, return to the dashboard and open their Appraisal Submission.
// // //           </Subtitle>

// // //           {loading ? (
// // //             <StateBox>
// // //               <Spinner />
// // //               Loading staff records...
// // //             </StateBox>
// // //           ) : error ? (
// // //             <StateBox type="error">{error}</StateBox>
// // //           ) : (
// // //             <>
// // //               {/* DESKTOP TABLE */}
// // //               <GoalsTableContainer>
// // //                 <GoalsTable>
// // //                   <thead>
// // //                     <tr>
// // //                       <Th style={{ width: "31%" }}>Goals</Th>
// // //                       <Th style={{ width: "23%" }}>Achievements</Th>
// // //                       <Th style={{ width: "23%" }}>Comments</Th>
// // //                       <Th style={{ width: "23%" }}>Admin Feedback</Th>
// // //                     </tr>
// // //                   </thead>

// // //                   <tbody>
// // //                     {submittedGoals.length > 0 ? (
// // //                       <>
// // //                         {monthlyGoals.map((month) => (
// // //                           <React.Fragment key={month._id}>
// // //                             <MonthlyTr>
// // //                               <Td style={{ background: "#f0f9ff", borderLeft: "6px solid #3b82f6" }}>
// // //                                 <MonthlyBlock>
// // //                                   <MonthlyTag>Monthly Goal</MonthlyTag>
// // //                                   <div style={{ marginTop: "6px", marginBottom: "4px" }}>
// // //                                     <UnitBadge>{getGoalUnit(month)}</UnitBadge>
// // //                                   </div>
// // //                                   <GoalText>{month.goal}</GoalText>
// // //                                   <GoalMeta>{formatNiceDate(month.startDate)} — {formatNiceDate(month.deliveryDate)}</GoalMeta>
// // //                                 </MonthlyBlock>
// // //                               </Td>
// // //                               <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
// // //                               <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
// // //                               <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
// // //                             </MonthlyTr>

// // //                             {filteredWeeklies.filter((w) => w.parentMonthlyGoal === month._id).map((week) => (
// // //                               <WeeklyTr key={week._id}>
// // //                                 <Td>
// // //                                   <WeeklyGoalWrap>
// // //                                     <WeeklyTitle>{getWeekLabel(week.weeklyDeliveryDate)} Goal</WeeklyTitle>
// // //                                     <GoalText>{week.goal}</GoalText>
// // //                                     <GoalMeta>Due {formatNiceDate(week.weeklyDeliveryDate)}</GoalMeta>
// // //                                   </WeeklyGoalWrap>
// // //                                 </Td>
// // //                                 <Td>
// // //                                   {renderReadOnlyField(week.achievements, "No achievements submitted.")}
// // //                                 </Td>
// // //                                 <Td>
// // //                                   {renderReadOnlyField(week.comments, "No comments added.")}
// // //                                 </Td>
// // //                                 <Td>
// // //                                   {/* 🔥 NEW: Inline Message Display */}
// // //                                   {feedbackStatus[week._id] && (
// // //                                     <InlineMessage type={feedbackStatus[week._id].type}>
// // //                                       {feedbackStatus[week._id].text}
// // //                                     </InlineMessage>
// // //                                   )}
// // //                                   <FieldTextarea
// // //                                     value={editValues[`${week._id}_sup`] ?? week.supervisorComments ?? ""}
// // //                                     onChange={(e) => handleEditChange(week._id, "sup", e.target.value)}
// // //                                     placeholder="Type feedback for this week..."
// // //                                   />
// // //                                   <SendButton
// // //                                     onClick={() => saveFeedback(week._id)}
// // //                                     disabled={updatingId === week._id}
// // //                                   >
// // //                                     {updatingId === week._id ? "Sending..." : "Send to Staff"}
// // //                                   </SendButton>
// // //                                 </Td>
// // //                               </WeeklyTr>
// // //                             ))}
// // //                           </React.Fragment>
// // //                         ))}

// // //                         {routineGoals.map((routine) => (
// // //                           <tr key={routine._id}>
// // //                             <Td style={{ borderLeft: "6px solid #ea580c" }}>
// // //                               <MonthlyBlock>
// // //                                 <RoutineTag>Other Goal</RoutineTag>
// // //                                 <GoalText>{routine.goal}</GoalText>
// // //                                 <GoalMeta>Due {formatNiceDate(routine.deliveryDate)}</GoalMeta>
// // //                               </MonthlyBlock>
// // //                             </Td>
// // //                             <Td>
// // //                               {renderReadOnlyField(routine.achievements, "No achievements submitted.")}
// // //                             </Td>
// // //                             <Td>
// // //                               {renderReadOnlyField(routine.comments, "No comments added.")}
// // //                             </Td>
// // //                             <Td>
// // //                               {/* 🔥 NEW: Inline Message Display */}
// // //                               {feedbackStatus[routine._id] && (
// // //                                 <InlineMessage type={feedbackStatus[routine._id].type}>
// // //                                   {feedbackStatus[routine._id].text}
// // //                                 </InlineMessage>
// // //                               )}
// // //                               <FieldTextarea
// // //                                 value={editValues[`${routine._id}_sup`] ?? routine.supervisorComments ?? ""}
// // //                                 onChange={(e) => handleEditChange(routine._id, "sup", e.target.value)}
// // //                                 placeholder="Type feedback for this routine goal..."
// // //                               />
// // //                               <SendButton
// // //                                 onClick={() => saveFeedback(routine._id)}
// // //                                 disabled={updatingId === routine._id}
// // //                               >
// // //                                 {updatingId === routine._id ? "Sending..." : "Send to Staff"}
// // //                               </SendButton>
// // //                             </Td>
// // //                           </tr>
// // //                         ))}
// // //                       </>
// // //                     ) : (
// // //                       <tr>
// // //                         <Td colSpan="4"><NoData>No goals submitted yet for this month.</NoData></Td>
// // //                       </tr>
// // //                     )}
// // //                   </tbody>
// // //                 </GoalsTable>
// // //               </GoalsTableContainer>

// // //               {/* MOBILE LAYOUT */}
// // //               <GoalsMobileGrid>
// // //                 {submittedGoals.length > 0 ? (
// // //                   <>
// // //                     {monthlyGoals.map((month) => (
// // //                       <React.Fragment key={month._id}>
// // //                         <GoalCard>
// // //                           <GoalCardHeader><Pill>Monthly Goal</Pill></GoalCardHeader>
// // //                           <div style={{ marginBottom: "10px" }}><UnitBadge>{getGoalUnit(month)}</UnitBadge></div>
// // //                           <GoalCardTitle>{month.goal}</GoalCardTitle>
// // //                           <GoalCardMeta>{formatNiceDate(month.startDate)} — {formatNiceDate(month.deliveryDate)}</GoalCardMeta>
// // //                         </GoalCard>

// // //                         {filteredWeeklies.filter((w) => w.parentMonthlyGoal === month._id).map((week) => (
// // //                           <GoalCard key={week._id}>
// // //                             <GoalCardHeader>
// // //                               <WeeklyTitle>{getWeekLabel(week.weeklyDeliveryDate)}</WeeklyTitle>
// // //                               <Pill>Weekly</Pill>
// // //                             </GoalCardHeader>
// // //                             <GoalCardTitle>{week.goal}</GoalCardTitle>
// // //                             <GoalCardMeta>Due {formatNiceDate(week.weeklyDeliveryDate)}</GoalCardMeta>
                            
// // //                             <SmallLabel>Achievements</SmallLabel>
// // //                             {renderReadOnlyField(week.achievements, "No achievements submitted.")}
                            
// // //                             <SmallLabel>Comments</SmallLabel>
// // //                             {renderReadOnlyField(week.comments, "No comments added.")}

// // //                             <SmallLabel>Admin Feedback</SmallLabel>
// // //                             {/* 🔥 NEW: Inline Message Display */}
// // //                             {feedbackStatus[week._id] && (
// // //                               <InlineMessage type={feedbackStatus[week._id].type}>
// // //                                 {feedbackStatus[week._id].text}
// // //                               </InlineMessage>
// // //                             )}
// // //                             <FieldTextarea
// // //                               value={editValues[`${week._id}_sup`] ?? week.supervisorComments ?? ""}
// // //                               onChange={(e) => handleEditChange(week._id, "sup", e.target.value)}
// // //                               placeholder="Type feedback for this week..."
// // //                             />
// // //                             <SendButton
// // //                               onClick={() => saveFeedback(week._id)}
// // //                               disabled={updatingId === week._id}
// // //                             >
// // //                               {updatingId === week._id ? "Sending..." : "Send to Staff"}
// // //                             </SendButton>
// // //                           </GoalCard>
// // //                         ))}
// // //                       </React.Fragment>
// // //                     ))}

// // //                     {routineGoals.map((routine) => (
// // //                       <GoalCard key={routine._id} variant="routine">
// // //                         <GoalCardHeader><Pill variant="routine">Other Goal</Pill></GoalCardHeader>
// // //                         <GoalCardTitle>{routine.goal}</GoalCardTitle>
// // //                         <GoalCardMeta>Due {formatNiceDate(routine.deliveryDate)}</GoalCardMeta>
                        
// // //                         <SmallLabel>Achievements</SmallLabel>
// // //                         {renderReadOnlyField(routine.achievements, "No achievements submitted.")}
                        
// // //                         <SmallLabel>Comments</SmallLabel>
// // //                         {renderReadOnlyField(routine.comments, "No comments added.")}

// // //                         <SmallLabel>Admin Feedback</SmallLabel>
// // //                         {/* 🔥 NEW: Inline Message Display */}
// // //                         {feedbackStatus[routine._id] && (
// // //                           <InlineMessage type={feedbackStatus[routine._id].type}>
// // //                             {feedbackStatus[routine._id].text}
// // //                           </InlineMessage>
// // //                         )}
// // //                         <FieldTextarea
// // //                           value={editValues[`${routine._id}_sup`] ?? routine.supervisorComments ?? ""}
// // //                           onChange={(e) => handleEditChange(routine._id, "sup", e.target.value)}
// // //                           placeholder="Type feedback for this routine goal..."
// // //                         />
// // //                         <SendButton
// // //                           onClick={() => saveFeedback(routine._id)}
// // //                           disabled={updatingId === routine._id}
// // //                         >
// // //                           {updatingId === routine._id ? "Sending..." : "Send to Staff"}
// // //                         </SendButton>
// // //                       </GoalCard>
// // //                     ))}
// // //                   </>
// // //                 ) : (
// // //                   <EmptyCard>No goals submitted yet for this month.</EmptyCard>
// // //                 )}
// // //               </GoalsMobileGrid>

// // //               <PaginationContainer>
// // //                 {weeks.map((weekLabel, i) => (
// // //                   <PageButton
// // //                     key={i} className={currentPage === i + 1 ? "active" : ""} onClick={() => setCurrentPage(i + 1)} type="button"
// // //                   >
// // //                     {weekLabel}
// // //                   </PageButton>
// // //                 ))}
// // //               </PaginationContainer>
// // //             </>
// // //           )}
// // //         </Card>
// // //       </PageWrapper>
// // //       <Footer />
// // //     </Container>
// // //   );
// // // };

// // // export default SuperAdminStaffGoals;

// // //feedback

// // import React, { useEffect, useMemo, useState } from "react";
// // import styled from "styled-components";
// // import { useParams, useNavigate } from "react-router-dom";
// // import { FaArrowLeft } from "react-icons/fa";
// // import NavBarSuper from "./NavBarSuper";
// // import Footer from "./Footer";
// // import api from "../api";

// // /* ================= HELPERS ================= */
// // const getCurrentMonthName = () => {
// //   const date = new Date();
// //   return date.toLocaleString("default", { month: "long", year: "numeric" });
// // };

// // // Generate a list of months for the dropdown (3 months past, 9 months future)
// // const generateMonthOptions = () => {
// //   const months = [];
// //   const date = new Date();
// //   date.setMonth(date.getMonth() - 3); 
// //   for (let i = 0; i < 12; i++) {
// //     months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
// //     date.setMonth(date.getMonth() + 1);
// //   }
// //   return months;
// // };

// // // Format "April 2026" to "2026-04" for backend queries
// // const formatToYearMonth = (periodString) => {
// //   if (!periodString) return "";
// //   const d = new Date(periodString);
// //   if (isNaN(d.getTime())) return "";
// //   const y = d.getFullYear();
// //   const m = String(d.getMonth() + 1).padStart(2, "0");
// //   return `${y}-${m}`;
// // };

// // const getWeekLabel = (dateInput) => {
// //   if (!dateInput) return "Unknown Week";
// //   let date;
// //   if (dateInput instanceof Date) {
// //     date = dateInput;
// //   } else if (typeof dateInput === 'string') {
// //     const datePart = dateInput.includes('T') ? dateInput.split('T')[0] : dateInput;
// //     const parts = datePart.split('-'); 
// //     if (parts.length !== 3) return "Invalid Date";
// //     date = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
// //   } else {
// //     return "Invalid Date";
// //   }
// //   if (isNaN(date.getTime())) return "Invalid Date";
// //   const sunday = new Date(date);
// //   sunday.setDate(date.getDate() - date.getDay());
// //   const saturday = new Date(sunday);
// //   saturday.setDate(sunday.getDate() + 6);
// //   const getWeekNum = (d) => {
// //     const firstDay = new Date(d.getFullYear(), d.getMonth(), 1).getDay();
// //     return Math.ceil((d.getDate() + firstDay) / 7);
// //   };
// //   if (sunday.getMonth() === saturday.getMonth()) {
// //     return `Week ${getWeekNum(saturday)}`;
// //   } else {
// //     const nextMonthName = saturday.toLocaleString("default", { month: "long" });
// //     return `Week ${getWeekNum(sunday)} / ${nextMonthName} Week ${getWeekNum(saturday)}`;
// //   }
// // };

// // const formatNiceDate = (dateString) => {
// //   if (!dateString) return "—";
// //   const date = new Date(dateString);
// //   if (isNaN(date.getTime())) return "Invalid date";
// //   const month = date.toLocaleString("default", { month: "long" });
// //   const day = date.getDate();
// //   const year = date.getFullYear();
// //   let suffix = "th";
// //   if (day % 10 === 1 && day % 100 !== 11) suffix = "st";
// //   else if (day % 10 === 2 && day % 100 !== 12) suffix = "nd";
// //   else if (day % 10 === 3 && day % 100 !== 13) suffix = "rd";
// //   return `${month} ${day}${suffix}, ${year}`;
// // };

// // const getGoalUnit = (goal) => {
// //   let unitVal = goal.unit || goal.subDepartment || "";
// //   if (typeof unitVal !== 'string') {
// //     unitVal = String(unitVal);
// //   }
// //   return unitVal;
// // };

// // /* ================= SHARED COMPONENTS ================= */
// // const ExpandableText = ({ text, limit = 90, isWeekly = false }) => {
// //   const [isExpanded, setIsExpanded] = useState(false);
// //   if (!text) return null;

// //   const textStyle = {
// //     maxWidth: "350px",
// //     wordWrap: "break-word",
// //     marginTop: isWeekly ? "4px" : "10px",
// //     fontWeight: isWeekly ? "600" : "700",
// //     color: "#0f172a",
// //     fontSize: isWeekly ? "13px" : "14px",
// //     lineHeight: "1.5",
// //   };

// //   if (String(text).length <= limit) {
// //     return <div style={textStyle}>{text}</div>;
// //   }

// //   return (
// //     <div style={{ ...textStyle, display: "block" }}>
// //       <span style={{ display: "inline" }}>
// //         {isExpanded ? text : `${String(text).substring(0, limit)}...`}
// //       </span>
// //       <button
// //         type="button"
// //         onClick={(e) => {
// //           e.preventDefault();
// //           setIsExpanded(!isExpanded);
// //         }}
// //         style={{
// //           background: "none", border: "none", color: "#2563eb",
// //           cursor: "pointer", fontSize: "12px", fontWeight: "800",
// //           padding: "0 0 0 6px", textDecoration: "underline",
// //         }}
// //       >
// //         {isExpanded ? "Show less" : "Read more"}
// //       </button>
// //     </div>
// //   );
// // };

// // /* ================= PAGE LAYOUT ================= */
// // const Container = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   min-height: 100vh;
// //   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// // `;

// // const PageWrapper = styled.div`
// //   flex: 1 0 auto;
// //   width: min(1380px, calc(100% - 32px));
// //   margin: 90px auto 40px;

// //   @media (max-width: 768px) {
// //     width: min(100%, calc(100% - 20px));
// //     margin-top: 80px;
// //   }
// // `;

// // const HeaderSection = styled.div`
// //   display: flex;
// //   justify-content: space-between;
// //   align-items: center;
// //   flex-wrap: wrap;
// //   gap: 16px;
// //   margin-bottom: 24px;
// // `;

// // const BackButton = styled.button`
// //   display: inline-flex;
// //   align-items: center;
// //   gap: 8px;
// //   background: none;
// //   border: none;
// //   color: #1d4ed8;
// //   font-weight: 800;
// //   font-size: 1rem;
// //   cursor: pointer;
// //   transition: transform 0.2s ease;
// //   padding: 0;

// //   &:hover {
// //     transform: translateX(-4px);
// //   }
// // `;

// // const HeroCard = styled.div`
// //   background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #1d4ed8 100%);
// //   color: #fff;
// //   border-radius: 24px;
// //   padding: 32px;
// //   margin-bottom: 24px;
// //   box-shadow: 0 15px 35px rgba(15, 23, 42, 0.1);
// //   display: flex;
// //   justify-content: space-between;
// //   align-items: center;
// //   flex-wrap: wrap;
// //   gap: 20px;
// // `;

// // const HeroTitle = styled.h1`
// //   margin: 0 0 10px;
// //   font-size: clamp(1.6rem, 1.2rem + 1.2vw, 2.4rem);
// //   font-weight: 800;
// // `;

// // const HeroText = styled.p`
// //   margin: 0;
// //   color: rgba(255, 255, 255, 0.86);
// //   font-size: 1.05rem;
// //   max-width: 800px;
// //   line-height: 1.5;
// // `;

// // /* ================= CARDS / TABLES ================= */
// // const Card = styled.div`
// //   background: rgba(255, 255, 255, 0.96);
// //   border-radius: 28px;
// //   padding: 24px;
// //   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
// //   border: 1px solid rgba(148, 163, 184, 0.16);
// //   margin-bottom: 34px;

// //   @media (max-width: 768px) { padding: 18px; border-radius: 22px; }
// // `;

// // const TitleRow = styled.div`
// //   display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 10px;
// // `;

// // const SectionTitle = styled.h2`
// //   font-size: clamp(1.15rem, 1rem + 0.6vw, 1.5rem); color: #1f2937; margin: 0; font-weight: 800;
// // `;

// // const GlobalMonthSelect = styled.select`
// //   padding: 6px 16px; border-radius: 12px; border: 2px solid #bfdbfe; font-size: 1.1rem;
// //   font-weight: 800; color: #1d4ed8; background: #eff6ff; outline: none; cursor: pointer; transition: all 0.2s;
// //   &:focus { border-color: #3b82f6; box-shadow: 0 0 0 4px rgba(59,130,246,0.1); }
// // `;

// // const Subtitle = styled.p` color: #6b7280; margin: 0 0 24px; font-size: 0.98rem; line-height: 1.6; `;

// // /* ================= BADGES ================= */
// // const UnitBadge = styled.span`
// //   display: inline-block; padding: 5px 10px; background: #e0f2fe; color: #0369a1; border: 1px solid #bae6fd;
// //   border-radius: 6px; font-size: 11px; font-weight: 800; letter-spacing: 0.05em; text-transform: uppercase;
// // `;

// // /* ================= GOALS TABLE DESKTOP ================= */
// // const GoalsTableContainer = styled.div`
// //   border-radius: 18px; border: 1px solid #e2e8f0; background: white; width: 100%; overflow: hidden;
// //   @media (max-width: 900px) { display: none; }
// // `;

// // const GoalsTable = styled.table` width: 100%; border-collapse: collapse; background: white; table-layout: fixed; `;
// // const Th = styled.th` background: #f8fafc; padding: 18px 20px; text-align: left; font-weight: 700; color: #1e293b; border-bottom: 2px solid #e2e8f0; font-size: 14px; `;
// // const Td = styled.td` padding: 18px 20px; border-bottom: 1px solid #f1f5f9; color: #1f2937; font-size: 15px; vertical-align: top; white-space: normal; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; max-width: 0; `;
// // const MonthlyTr = styled.tr` background: #f0f9ff; `;
// // const WeeklyTr = styled.tr` background: #fff; `;
// // const MonthlyBlock = styled.div` padding: 8px 0; `;
// // const MonthlyTag = styled.div` color: #1e40af; font-size: 13px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; `;
// // const RoutineTag = styled(MonthlyTag)` color: #ea580c; `;
// // const GoalText = styled.div` margin-top: 10px; font-weight: 700; font-size: 16px; line-height: 1.5; color: #0f172a; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; white-space: normal; width: 100%; `;
// // const GoalMeta = styled.div` margin-top: 6px; color: #2563eb; font-size: 14px; font-weight: 700; line-height: 1.5; `;
// // const WeeklyGoalWrap = styled.div` display: grid; gap: 6px; min-width: 0; position: relative; padding-left: 16px; border-left: 2px solid #cbd5f5; &::before { content: ""; position: absolute; left: -6px; top: 16px; width: 10px; height: 2px; background: #3b82f6; } `;
// // const WeeklyTitle = styled.div` font-weight: 800; font-size: 12px; color: #1d4ed8; text-transform: uppercase; letter-spacing: 0.04em; display: flex; align-items: center; gap: 6px; &::before { content: "→"; font-size: 14px; color: #3b82f6; } `;
// // const NoData = styled.p` text-align: center; color: #6b7280; font-style: italic; padding: 60px 20px; font-size: 15.5px; `;

// // const ReadOnlyText = styled.div`
// //   width: 100%; min-height: 60px; padding: 14px; font-size: 14px; line-height: 1.6;
// //   background: #f8fafc; color: #334155; border-radius: 12px; border: 1px solid #e2e8f0;
// //   white-space: pre-wrap;
// // `;

// // const EmptyStateText = styled(ReadOnlyText)`
// //   color: #94a3b8; font-style: italic; background: #fdfdfd; border: 1px dashed #cbd5e1;
// // `;

// // /* 🔥 NEW: Interactive Feedback Styles */
// // const FieldTextarea = styled.textarea` 
// //   width: 100%; min-height: 80px; border: 1px solid #fcd34d; border-radius: 10px; padding: 12px; 
// //   font-size: 14px; resize: vertical; box-sizing: border-box; transition: all 0.2s;
// //   background: #fffbeb; color: #1f2937; margin-bottom: 8px;
// //   &:focus { border-color: #d97706; box-shadow: 0 0 0 4px rgba(217, 119, 6, 0.12); outline: none; } 
// // `;

// // const SendButton = styled.button` 
// //   background: #d97706; color: white; border: none; padding: 10px 16px; border-radius: 8px; 
// //   font-weight: 700; cursor: pointer; font-size: 13px; width: 100%; transition: all 0.2s;
// //   &:disabled { opacity: 0.6; cursor: not-allowed; } 
// //   &:hover:not(:disabled) { background: #b45309; } 
// // `;

// // const InlineMessage = styled.div`
// //   font-size: 12px;
// //   font-weight: 700;
// //   padding: 8px 10px;
// //   border-radius: 8px;
// //   margin-bottom: 8px;
// //   text-align: center;
// //   background: ${({ type }) => type === 'success' ? 'rgba(22, 163, 74, 0.1)' : 'rgba(220, 38, 38, 0.1)'};
// //   color: ${({ type }) => type === 'success' ? '#16a34a' : '#dc2626'};
// //   border: 1px solid ${({ type }) => type === 'success' ? 'rgba(22, 163, 74, 0.2)' : 'rgba(220, 38, 38, 0.2)'};
// // `;

// // /* ================= RESPONSIVE GOAL CARDS ================= */
// // const GoalsMobileGrid = styled.div` display: none; @media (max-width: 900px) { display: grid; gap: 16px; } `;
// // const GoalCard = styled.div` background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%); border: 1px solid rgba(148, 163, 184, 0.18); border-left: 5px solid ${({ variant }) => (variant === "routine" ? "#ea580c" : "#3b82f6")}; border-radius: 22px; padding: 18px; box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06); position: relative; `;
// // const GoalCardHeader = styled.div` display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; flex-wrap: wrap; margin-bottom: 14px; `;
// // const Pill = styled.div` display: inline-flex; align-items: center; padding: 8px 12px; border-radius: 999px; font-size: 12px; font-weight: 800; letter-spacing: 0.04em; text-transform: uppercase; background: ${({ variant }) => variant === "routine" ? "rgba(234, 88, 12, 0.12)" : "rgba(37,99,235,0.12)"}; color: ${({ variant }) => (variant === "routine" ? "#ea580c" : "#1d4ed8")}; `;
// // const GoalCardTitle = styled.div` font-size: 1rem; font-weight: 800; line-height: 1.5; color: #0f172a; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; white-space: normal; `;
// // const GoalCardMeta = styled.div` margin-top: 6px; font-size: 14px; color: #64748b; line-height: 1.5; `;
// // const SmallLabel = styled.div` font-size: 12px; font-weight: 800; color: #64748b; margin: 14px 0 6px; text-transform: uppercase; letter-spacing: 0.04em; `;
// // const EmptyCard = styled.div` padding: 28px 20px; text-align: center; border-radius: 18px; background: #f8fafc; border: 1px dashed #cbd5e1; color: #64748b; `;

// // /* ================= PAGINATION ================= */
// // const PaginationContainer = styled.div` display: flex; justify-content: center; align-items: center; gap: 12px; margin-top: 28px; flex-wrap: wrap; `;
// // const PageButton = styled.button` padding: 10px 18px; border: 1px solid #cbd5e1; background: white; border-radius: 9999px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; &:hover:not(:disabled) { background: #f1f5f9; transform: translateY(-1px); color: #1e40af; } &:disabled { opacity: 0.5; cursor: not-allowed; } &.active { background: #1e40af; color: white; border-color: #1e40af; } `;

// // /* ================= STATES ================= */
// // const StateBox = styled.div`
// //   text-align: center; padding: 50px 20px; border-radius: 18px;
// //   background: ${({ type }) => type === 'error' ? '#fef2f2' : '#ffffff'};
// //   color: ${({ type }) => type === 'error' ? '#dc2626' : '#64748b'};
// //   border: 1px solid ${({ type }) => type === 'error' ? '#fecaca' : '#e2e8f0'};
// //   font-size: 1rem;
// // `;

// // const Spinner = styled.div`
// //   width: 40px; height: 40px; margin: 0 auto 16px; border-radius: 50%;
// //   border: 4px solid #e0ecff; border-top-color: #1d4ed8; animation: spin 0.8s linear infinite;
// //   @keyframes spin { to { transform: rotate(360deg); } }
// // `;

// // /* ================= COMPONENT ================= */
// // const SuperAdminStaffGoals = ({ user }) => {
// //   const { userId } = useParams();
// //   const navigate = useNavigate();
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [staffInfo, setStaffInfo] = useState(null);

// //   // 🔥 NEW STATE FOR FEEDBACK INLINE MESSAGES
// //   const [editValues, setEditValues] = useState({});
// //   const [updatingId, setUpdatingId] = useState(null);
// //   const [feedbackStatus, setFeedbackStatus] = useState({}); // Stores { type: 'success'|'error', text: '' }

// //   const availableMonths = useMemo(() => generateMonthOptions(), []);
  
// //   // Use a different storage key so it doesn't conflict with their own dashboard state
// //   const [selectedMonth, setSelectedMonth] = useState(
// //     localStorage.getItem("superAdminViewMonth") || getCurrentMonthName()
// //   );

// //   const [submittedGoals, setSubmittedGoals] = useState([]);
// //   const [currentPage, setCurrentPage] = useState(1);

// //   useEffect(() => {
// //     localStorage.setItem("superAdminViewMonth", selectedMonth);
// //   }, [selectedMonth]);

  
// //   useEffect(() => {
// //     const fetchStaffGoals = async () => {
// //       try {
// //         setLoading(true);
// //         setError(null);
        
// //         // We need to fetch the goals for this specific user. 
// //         const targetMonthParam = formatToYearMonth(selectedMonth);
        
// //         const res = await api.get(`/goals/admin/user-month/${userId}?targetMonth=${targetMonthParam}`);
        
// //         setSubmittedGoals(res.data.data || []);
// //         if (res.data.staff) setStaffInfo(res.data.staff);
        
// //       } catch (err) {
// //         console.error(err);
// //         setError(err.response?.data?.message || 'Failed to fetch staff goals');
// //         setSubmittedGoals([]);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     if (userId) {
// //       fetchStaffGoals();
// //     }
// //   }, [userId, selectedMonth]);

// //   const monthlyGoals = submittedGoals.filter((g) => g.type === "monthly");
// //   const weeklyGoals = submittedGoals.filter((g) => g.type === "weekly");
// //   const routineGoals = submittedGoals.filter((g) => g.type === "routine");

// //   const descendingWeeklyGoals = [...weeklyGoals].sort((a, b) => new Date(b.weeklyDeliveryDate).getTime() - new Date(a.weeklyDeliveryDate).getTime());
// //   const weeks = [...new Set(descendingWeeklyGoals.map((w) => getWeekLabel(w.weeklyDeliveryDate)))];
// //   const maxPages = Math.max(weeks.length, 1);
// //   const displayWeek = weeks[currentPage - 1] || getWeekLabel(new Date());
  
// //   const filteredWeeklies = weeklyGoals.filter((w) => getWeekLabel(w.weeklyDeliveryDate) === displayWeek);

// //   const renderReadOnlyField = (content, placeholder) => {
// //     if (!content || !content.trim()) {
// //       return <EmptyStateText>{placeholder}</EmptyStateText>;
// //     }
// //     return <ReadOnlyText>{content}</ReadOnlyText>;
// //   };

// //   // 🔥 HANDLERS FOR INLINE FEEDBACK
// //   const handleEditChange = (id, field, value) => {
// //     setEditValues((prev) => ({
// //       ...prev,
// //       [`${id}_${field}`]: value,
// //     }));
// //   };

// //   // const saveFeedback = async (goalId) => {
// //   //   // 🔥 FIX: Check if we are updating superAdminComments based on the new schema field
// //   //   const superAdminComments = editValues[`${goalId}_sup`] !== undefined 
// //   //     ? editValues[`${goalId}_sup`] 
// //   //     : submittedGoals.find(g => g._id === goalId)?.superAdminComments || "";

// //   //   setUpdatingId(goalId);
    
// //   //   // Clear any previous message for this goal
// //   //   setFeedbackStatus((prev) => ({ ...prev, [goalId]: null }));

// //   //   try {
// //   //     // 🔥 FIX: Pointing to the specific super-admin-comment endpoint
// //   //     await api.put(`/goals/super-admin-comment/${goalId}`, { comment: superAdminComments });
      
// //   //     // Show success inline message
// //   //     setFeedbackStatus((prev) => ({
// //   //       ...prev,
// //   //       [goalId]: { type: "success", text: "Sent to staff!" }
// //   //     }));

// //   //     // Hide success message after 3 seconds
// //   //     setTimeout(() => {
// //   //       setFeedbackStatus((prev) => ({ ...prev, [goalId]: null }));
// //   //     }, 3000);

// //   //   } catch (err) {
// //   //     console.error(err);
// //   //     // Show error inline message
// //   //     setFeedbackStatus((prev) => ({
// //   //       ...prev,
// //   //       [goalId]: { type: "error", text: "Failed to send" }
// //   //     }));
// //   //   } finally {
// //   //     setUpdatingId(null);
// //   //   }
// //   // };

// //   const saveFeedback = async (goalId) => {
// //     // Only grab the NEW text typed into the textarea
// //     const newComment = editValues[`${goalId}_sup`];

// //     if (!newComment || !newComment.trim()) {
// //       return; // Don't submit if the field is empty
// //     }

// //     setUpdatingId(goalId);
// //     setFeedbackStatus((prev) => ({ ...prev, [goalId]: null }));

// //     try {
// //       const res = await api.put(`/goals/super-admin-comment/${goalId}`, { comment: newComment });
      
// //       // 1. Update the local goals state so the new comment appears immediately
// //       setSubmittedGoals((prevGoals) => 
// //         prevGoals.map((g) => g._id === goalId ? res.data.goal : g)
// //       );

// //       // 2. Clear the textarea so it's ready for another comment later
// //       setEditValues((prev) => ({ ...prev, [`${goalId}_sup`]: "" }));

// //       setFeedbackStatus((prev) => ({
// //         ...prev,
// //         [goalId]: { type: "success", text: "Sent to staff!" }
// //       }));

// //       setTimeout(() => {
// //         setFeedbackStatus((prev) => ({ ...prev, [goalId]: null }));
// //       }, 3000);

// //     } catch (err) {
// //       console.error(err);
// //       setFeedbackStatus((prev) => ({
// //         ...prev,
// //         [goalId]: { type: "error", text: "Failed to send" }
// //       }));
// //     } finally {
// //       setUpdatingId(null);
// //     }
// //   };

// //   return (
// //     <Container>
// //       <NavBarSuper user={user} />

// //       <PageWrapper>
// //         <HeaderSection>
// //           <BackButton onClick={() => navigate('/super-admin/dashboard')}>
// //             <FaArrowLeft /> Back to Directory
// //           </BackButton>
// //         </HeaderSection>

// //         <HeroCard>
// //           <div>
// //             <HeroTitle>Staff Goal Review</HeroTitle>
// //             <HeroText>
// //               Reviewing the submitted goals, achievements, and comments for <strong>{staffInfo?.firstName || 'this staff member'}</strong>. Send feedback directly to their dashboard.
// //             </HeroText>
// //           </div>
// //         </HeroCard>

// //         <Card>
// //           <TitleRow>
// //             <SectionTitle>Viewing Goals for</SectionTitle>
// //             <GlobalMonthSelect value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
// //               {availableMonths.map(m => (
// //                 <option key={m} value={m}>{m}</option>
// //               ))}
// //             </GlobalMonthSelect>
// //           </TitleRow>

// //           <Subtitle>
// //             Read their achievements and send weekly/routine feedback directly below. To formally score these, return to the dashboard and open their Appraisal Submission.
// //           </Subtitle>

// //           {loading ? (
// //             <StateBox>
// //               <Spinner />
// //               Loading staff records...
// //             </StateBox>
// //           ) : error ? (
// //             <StateBox type="error">{error}</StateBox>
// //           ) : (
// //             <>
// //               {/* DESKTOP TABLE */}
// //               <GoalsTableContainer>
// //                 <GoalsTable>
// //                   <thead>
// //                     <tr>
// //                       <Th style={{ width: "31%" }}>Goals</Th>
// //                       <Th style={{ width: "23%" }}>Achievements</Th>
// //                       <Th style={{ width: "23%" }}>Comments</Th>
// //                       <Th style={{ width: "23%" }}>Admin Feedback</Th>
// //                     </tr>
// //                   </thead>

// //                   <tbody>
// //                     {submittedGoals.length > 0 ? (
// //                       <>
// //                         {monthlyGoals.map((month) => (
// //                           <React.Fragment key={month._id}>
// //                             <MonthlyTr>
// //                               <Td style={{ background: "#f0f9ff", borderLeft: "6px solid #3b82f6" }}>
// //                                 <MonthlyBlock>
// //                                   <MonthlyTag>Monthly Goal</MonthlyTag>
// //                                   <div style={{ marginTop: "6px", marginBottom: "4px" }}>
// //                                     <UnitBadge>{getGoalUnit(month)}</UnitBadge>
// //                                   </div>
// //                                   <GoalText>{month.goal}</GoalText>
// //                                   <GoalMeta>{formatNiceDate(month.startDate)} — {formatNiceDate(month.deliveryDate)}</GoalMeta>
// //                                 </MonthlyBlock>
// //                               </Td>
// //                               <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
// //                               <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
// //                               <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
// //                             </MonthlyTr>

// //                             {filteredWeeklies.filter((w) => w.parentMonthlyGoal === month._id).map((week) => (
// //                               <WeeklyTr key={week._id}>
// //                                 <Td>
// //                                   <WeeklyGoalWrap>
// //                                     <WeeklyTitle>{getWeekLabel(week.weeklyDeliveryDate)} Goal</WeeklyTitle>
// //                                     <GoalText>{week.goal}</GoalText>
// //                                     <GoalMeta>Due {formatNiceDate(week.weeklyDeliveryDate)}</GoalMeta>
// //                                   </WeeklyGoalWrap>
// //                                 </Td>
// //                                 <Td>
// //                                   {renderReadOnlyField(week.achievements, "No achievements submitted.")}
// //                                 </Td>
// //                                 <Td>
// //                                   {renderReadOnlyField(week.comments, "No comments added.")}
// //                                 </Td>
// //                                 <Td>
// //                                   {/* 🔥 NEW: Inline Message Display */}
// //                                   {feedbackStatus[week._id] && (
// //                                     <InlineMessage type={feedbackStatus[week._id].type}>
// //                                       {feedbackStatus[week._id].text}
// //                                     </InlineMessage>
// //                                   )}
// //                                   <FieldTextarea
// //                                     value={editValues[`${week._id}_sup`] ?? week.superAdminComments ?? ""} // 🔥 FIXED: Access superAdminComments
// //                                     onChange={(e) => handleEditChange(week._id, "sup", e.target.value)}
// //                                     placeholder="Type feedback for this week..."
// //                                   />
// //                                   <SendButton
// //                                     onClick={() => saveFeedback(week._id)}
// //                                     disabled={updatingId === week._id}
// //                                   >
// //                                     {updatingId === week._id ? "Sending..." : "Send to Staff"}
// //                                   </SendButton>
// //                                 </Td>
// //                               </WeeklyTr>
// //                             ))}
// //                           </React.Fragment>
// //                         ))}

// //                         {routineGoals.map((routine) => (
// //                           <tr key={routine._id}>
// //                             <Td style={{ borderLeft: "6px solid #ea580c" }}>
// //                               <MonthlyBlock>
// //                                 <RoutineTag>Other Goal</RoutineTag>
// //                                 <GoalText>{routine.goal}</GoalText>
// //                                 <GoalMeta>Due {formatNiceDate(routine.deliveryDate)}</GoalMeta>
// //                               </MonthlyBlock>
// //                             </Td>
// //                             <Td>
// //                               {renderReadOnlyField(routine.achievements, "No achievements submitted.")}
// //                             </Td>
// //                             <Td>
// //                               {renderReadOnlyField(routine.comments, "No comments added.")}
// //                             </Td>
// //                             <Td>
// //                               {/* 🔥 NEW: Inline Message Display */}
// //                               {feedbackStatus[routine._id] && (
// //                                 <InlineMessage type={feedbackStatus[routine._id].type}>
// //                                   {feedbackStatus[routine._id].text}
// //                                 </InlineMessage>
// //                               )}
// //                               <FieldTextarea
// //                                 value={editValues[`${routine._id}_sup`] ?? routine.superAdminComments ?? ""} // 🔥 FIXED: Access superAdminComments
// //                                 onChange={(e) => handleEditChange(routine._id, "sup", e.target.value)}
// //                                 placeholder="Type feedback for this routine goal..."
// //                               />
// //                               <SendButton
// //                                 onClick={() => saveFeedback(routine._id)}
// //                                 disabled={updatingId === routine._id}
// //                               >
// //                                 {updatingId === routine._id ? "Sending..." : "Send to Staff"}
// //                               </SendButton>
// //                             </Td>
// //                           </tr>
// //                         ))}
// //                       </>
// //                     ) : (
// //                       <tr>
// //                         <Td colSpan="4"><NoData>No goals submitted yet for this month.</NoData></Td>
// //                       </tr>
// //                     )}
// //                   </tbody>
// //                 </GoalsTable>
// //               </GoalsTableContainer>

// //               {/* MOBILE LAYOUT */}
// //               <GoalsMobileGrid>
// //                 {submittedGoals.length > 0 ? (
// //                   <>
// //                     {monthlyGoals.map((month) => (
// //                       <React.Fragment key={month._id}>
// //                         <GoalCard>
// //                           <GoalCardHeader><Pill>Monthly Goal</Pill></GoalCardHeader>
// //                           <div style={{ marginBottom: "10px" }}><UnitBadge>{getGoalUnit(month)}</UnitBadge></div>
// //                           <GoalCardTitle>{month.goal}</GoalCardTitle>
// //                           <GoalCardMeta>{formatNiceDate(month.startDate)} — {formatNiceDate(month.deliveryDate)}</GoalCardMeta>
// //                         </GoalCard>

// //                         {filteredWeeklies.filter((w) => w.parentMonthlyGoal === month._id).map((week) => (
// //                           <GoalCard key={week._id}>
// //                             <GoalCardHeader>
// //                               <WeeklyTitle>{getWeekLabel(week.weeklyDeliveryDate)}</WeeklyTitle>
// //                               <Pill>Weekly</Pill>
// //                             </GoalCardHeader>
// //                             <GoalCardTitle>{week.goal}</GoalCardTitle>
// //                             <GoalCardMeta>Due {formatNiceDate(week.weeklyDeliveryDate)}</GoalCardMeta>
                            
// //                             <SmallLabel>Achievements</SmallLabel>
// //                             {renderReadOnlyField(week.achievements, "No achievements submitted.")}
                            
// //                             <SmallLabel>Comments</SmallLabel>
// //                             {renderReadOnlyField(week.comments, "No comments added.")}

// //                             <SmallLabel>Admin Feedback</SmallLabel>
// //                             {/* 🔥 NEW: Inline Message Display */}
// //                             {feedbackStatus[week._id] && (
// //                               <InlineMessage type={feedbackStatus[week._id].type}>
// //                                 {feedbackStatus[week._id].text}
// //                               </InlineMessage>
// //                             )}
// //                             <FieldTextarea
// //                               value={editValues[`${week._id}_sup`] ?? week.superAdminComments ?? ""} // 🔥 FIXED: Access superAdminComments
// //                               onChange={(e) => handleEditChange(week._id, "sup", e.target.value)}
// //                               placeholder="Type feedback for this week..."
// //                             />
// //                             <SendButton
// //                               onClick={() => saveFeedback(week._id)}
// //                               disabled={updatingId === week._id}
// //                             >
// //                               {updatingId === week._id ? "Sending..." : "Send to Staff"}
// //                             </SendButton>
// //                           </GoalCard>
// //                         ))}
// //                       </React.Fragment>
// //                     ))}

// //                     {routineGoals.map((routine) => (
// //                       <GoalCard key={routine._id} variant="routine">
// //                         <GoalCardHeader><Pill variant="routine">Other Goal</Pill></GoalCardHeader>
// //                         <GoalCardTitle>{routine.goal}</GoalCardTitle>
// //                         <GoalCardMeta>Due {formatNiceDate(routine.deliveryDate)}</GoalCardMeta>
                        
// //                         <SmallLabel>Achievements</SmallLabel>
// //                         {renderReadOnlyField(routine.achievements, "No achievements submitted.")}
                        
// //                         <SmallLabel>Comments</SmallLabel>
// //                         {renderReadOnlyField(routine.comments, "No comments added.")}

// //                         <SmallLabel>Admin Feedback</SmallLabel>
// //                         {/* 🔥 NEW: Inline Message Display */}
// //                         {feedbackStatus[routine._id] && (
// //                           <InlineMessage type={feedbackStatus[routine._id].type}>
// //                             {feedbackStatus[routine._id].text}
// //                           </InlineMessage>
// //                         )}
// //                         <FieldTextarea
// //                           value={editValues[`${routine._id}_sup`] ?? routine.superAdminComments ?? ""} // 🔥 FIXED: Access superAdminComments
// //                           onChange={(e) => handleEditChange(routine._id, "sup", e.target.value)}
// //                           placeholder="Type feedback for this routine goal..."
// //                         />
// //                         <SendButton
// //                           onClick={() => saveFeedback(routine._id)}
// //                           disabled={updatingId === routine._id}
// //                         >
// //                           {updatingId === routine._id ? "Sending..." : "Send to Staff"}
// //                         </SendButton>
// //                       </GoalCard>
// //                     ))}
// //                   </>
// //                 ) : (
// //                   <EmptyCard>No goals submitted yet for this month.</EmptyCard>
// //                 )}
// //               </GoalsMobileGrid>

// //               <PaginationContainer>
// //                 {weeks.map((weekLabel, i) => (
// //                   <PageButton
// //                     key={i} className={currentPage === i + 1 ? "active" : ""} onClick={() => setCurrentPage(i + 1)} type="button"
// //                   >
// //                     {weekLabel}
// //                   </PageButton>
// //                 ))}
// //               </PaginationContainer>
// //             </>
// //           )}
// //         </Card>
// //       </PageWrapper>
// //       <Footer />
// //     </Container>
// //   );
// // };

// // export default SuperAdminStaffGoals;

// ///api/goals/super-admin/all:500

// // {/* <FieldTextarea
// //   // 🔥 FIX: Add ?.text right here so it pulls the string out of the object
// //   value={editValues[`${week._id}_sup`] ?? week.superAdminComments?.text ?? ""} 
// //   onChange={(e) => handleEditChange(week._id, "sup", e.target.value)}
// //   placeholder="Type feedback for this week..."
// // /> */}


// import React, { useEffect, useMemo, useState } from "react";
// import styled from "styled-components";
// import { useParams, useNavigate } from "react-router-dom";
// import { FaArrowLeft } from "react-icons/fa";
// import NavBarSuper from "./NavBarSuper";
// import Footer from "./Footer";
// import api from "../api";

// /* ================= HELPERS ================= */
// const getCurrentMonthName = () => {
//   const date = new Date();
//   return date.toLocaleString("default", { month: "long", year: "numeric" });
// };

// const generateMonthOptions = () => {
//   const months = [];
//   const date = new Date();
//   date.setMonth(date.getMonth() - 3); 
//   for (let i = 0; i < 12; i++) {
//     months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
//     date.setMonth(date.getMonth() + 1);
//   }
//   return months;
// };

// const formatToYearMonth = (periodString) => {
//   if (!periodString) return "";
//   const d = new Date(periodString);
//   if (isNaN(d.getTime())) return "";
//   const y = d.getFullYear();
//   const m = String(d.getMonth() + 1).padStart(2, "0");
//   return `${y}-${m}`;
// };

// const getWeekLabel = (dateInput) => {
//   if (!dateInput) return "Unknown Week";
//   let date;
//   if (dateInput instanceof Date) {
//     date = dateInput;
//   } else if (typeof dateInput === 'string') {
//     const datePart = dateInput.includes('T') ? dateInput.split('T')[0] : dateInput;
//     const parts = datePart.split('-'); 
//     if (parts.length !== 3) return "Invalid Date";
//     date = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
//   } else {
//     return "Invalid Date";
//   }
//   if (isNaN(date.getTime())) return "Invalid Date";
//   const sunday = new Date(date);
//   sunday.setDate(date.getDate() - date.getDay());
//   const saturday = new Date(sunday);
//   saturday.setDate(sunday.getDate() + 6);
//   const getWeekNum = (d) => {
//     const firstDay = new Date(d.getFullYear(), d.getMonth(), 1).getDay();
//     return Math.ceil((d.getDate() + firstDay) / 7);
//   };
//   if (sunday.getMonth() === saturday.getMonth()) {
//     return `Week ${getWeekNum(saturday)}`;
//   } else {
//     const nextMonthName = saturday.toLocaleString("default", { month: "long" });
//     return `Week ${getWeekNum(sunday)} / ${nextMonthName} Week ${getWeekNum(saturday)}`;
//   }
// };

// const formatNiceDate = (dateString) => {
//   if (!dateString) return "—";
//   const date = new Date(dateString);
//   if (isNaN(date.getTime())) return "Invalid date";
//   const month = date.toLocaleString("default", { month: "long" });
//   const day = date.getDate();
//   const year = date.getFullYear();
//   let suffix = "th";
//   if (day % 10 === 1 && day % 100 !== 11) suffix = "st";
//   else if (day % 10 === 2 && day % 100 !== 12) suffix = "nd";
//   else if (day % 10 === 3 && day % 100 !== 13) suffix = "rd";
//   return `${month} ${day}${suffix}, ${year}`;
// };

// const getGoalUnit = (goal) => {
//   let unitVal = goal.unit || goal.subDepartment || "";
//   if (typeof unitVal !== 'string') {
//     unitVal = String(unitVal);
//   }
//   return unitVal;
// };

// /* ================= SHARED COMPONENTS ================= */
// const ExpandableText = ({ text, limit = 90, isWeekly = false }) => {
//   const [isExpanded, setIsExpanded] = useState(false);
//   if (!text) return null;

//   const textStyle = {
//     maxWidth: "350px",
//     wordWrap: "break-word",
//     marginTop: isWeekly ? "4px" : "10px",
//     fontWeight: isWeekly ? "600" : "700",
//     color: "#0f172a",
//     fontSize: isWeekly ? "13px" : "14px",
//     lineHeight: "1.5",
//   };

//   if (String(text).length <= limit) {
//     return <div style={textStyle}>{text}</div>;
//   }

//   return (
//     <div style={{ ...textStyle, display: "block" }}>
//       <span style={{ display: "inline" }}>
//         {isExpanded ? text : `${String(text).substring(0, limit)}...`}
//       </span>
//       <button
//         type="button"
//         onClick={(e) => {
//           e.preventDefault();
//           setIsExpanded(!isExpanded);
//         }}
//         style={{
//           background: "none", border: "none", color: "#2563eb",
//           cursor: "pointer", fontSize: "12px", fontWeight: "800",
//           padding: "0 0 0 6px", textDecoration: "underline",
//         }}
//       >
//         {isExpanded ? "Show less" : "Read more"}
//       </button>
//     </div>
//   );
// };

// /* ================= PAGE LAYOUT ================= */
// const Container = styled.div`
//   display: flex;
//   flex-direction: column;
//   min-height: 100vh;
//   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// `;

// const PageWrapper = styled.div`
//   flex: 1 0 auto;
//   width: min(1380px, calc(100% - 32px));
//   margin: 90px auto 40px;

//   @media (max-width: 768px) {
//     width: min(100%, calc(100% - 20px));
//     margin-top: 80px;
//   }
// `;

// const HeaderSection = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   flex-wrap: wrap;
//   gap: 16px;
//   margin-bottom: 24px;
// `;

// const BackButton = styled.button`
//   display: inline-flex;
//   align-items: center;
//   gap: 8px;
//   background: none;
//   border: none;
//   color: #1d4ed8;
//   font-weight: 800;
//   font-size: 1rem;
//   cursor: pointer;
//   transition: transform 0.2s ease;
//   padding: 0;

//   &:hover {
//     transform: translateX(-4px);
//   }
// `;

// const HeroCard = styled.div`
//   background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #1d4ed8 100%);
//   color: #fff;
//   border-radius: 24px;
//   padding: 32px;
//   margin-bottom: 24px;
//   box-shadow: 0 15px 35px rgba(15, 23, 42, 0.1);
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   flex-wrap: wrap;
//   gap: 20px;
// `;

// const HeroTitle = styled.h1`
//   margin: 0 0 10px;
//   font-size: clamp(1.6rem, 1.2rem + 1.2vw, 2.4rem);
//   font-weight: 800;
// `;

// const HeroText = styled.p`
//   margin: 0;
//   color: rgba(255, 255, 255, 0.86);
//   font-size: 1.05rem;
//   max-width: 800px;
//   line-height: 1.5;
// `;

// /* ================= CARDS / TABLES ================= */
// const Card = styled.div`
//   background: rgba(255, 255, 255, 0.96);
//   border-radius: 28px;
//   padding: 24px;
//   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
//   border: 1px solid rgba(148, 163, 184, 0.16);
//   margin-bottom: 34px;

//   @media (max-width: 768px) { padding: 18px; border-radius: 22px; }
// `;

// const TitleRow = styled.div`
//   display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 10px;
// `;

// const SectionTitle = styled.h2`
//   font-size: clamp(1.15rem, 1rem + 0.6vw, 1.5rem); color: #1f2937; margin: 0; font-weight: 800;
// `;

// const GlobalMonthSelect = styled.select`
//   padding: 6px 16px; border-radius: 12px; border: 2px solid #bfdbfe; font-size: 1.1rem;
//   font-weight: 800; color: #1d4ed8; background: #eff6ff; outline: none; cursor: pointer; transition: all 0.2s;
//   &:focus { border-color: #3b82f6; box-shadow: 0 0 0 4px rgba(59,130,246,0.1); }
// `;

// const Subtitle = styled.p` color: #6b7280; margin: 0 0 24px; font-size: 0.98rem; line-height: 1.6; `;

// /* ================= BADGES ================= */
// const UnitBadge = styled.span`
//   display: inline-block; padding: 5px 10px; background: #e0f2fe; color: #0369a1; border: 1px solid #bae6fd;
//   border-radius: 6px; font-size: 11px; font-weight: 800; letter-spacing: 0.05em; text-transform: uppercase;
// `;

// /* ================= GOALS TABLE DESKTOP ================= */
// const GoalsTableContainer = styled.div`
//   border-radius: 18px; border: 1px solid #e2e8f0; background: white; width: 100%; overflow: hidden;
//   @media (max-width: 900px) { display: none; }
// `;

// const GoalsTable = styled.table` width: 100%; border-collapse: collapse; background: white; table-layout: fixed; `;
// const Th = styled.th` background: #f8fafc; padding: 18px 20px; text-align: left; font-weight: 700; color: #1e293b; border-bottom: 2px solid #e2e8f0; font-size: 14px; `;
// const Td = styled.td` padding: 18px 20px; border-bottom: 1px solid #f1f5f9; color: #1f2937; font-size: 15px; vertical-align: top; white-space: normal; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; max-width: 0; `;
// const MonthlyTr = styled.tr` background: #f0f9ff; `;
// const WeeklyTr = styled.tr` background: #fff; `;
// const MonthlyBlock = styled.div` padding: 8px 0; `;
// const MonthlyTag = styled.div` color: #1e40af; font-size: 13px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; `;
// const RoutineTag = styled(MonthlyTag)` color: #ea580c; `;
// const GoalText = styled.div` margin-top: 10px; font-weight: 700; font-size: 16px; line-height: 1.5; color: #0f172a; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; white-space: normal; width: 100%; `;
// const GoalMeta = styled.div` margin-top: 6px; color: #2563eb; font-size: 14px; font-weight: 700; line-height: 1.5; `;
// const WeeklyGoalWrap = styled.div` display: grid; gap: 6px; min-width: 0; position: relative; padding-left: 16px; border-left: 2px solid #cbd5f5; &::before { content: ""; position: absolute; left: -6px; top: 16px; width: 10px; height: 2px; background: #3b82f6; } `;
// const WeeklyTitle = styled.div` font-weight: 800; font-size: 12px; color: #1d4ed8; text-transform: uppercase; letter-spacing: 0.04em; display: flex; align-items: center; gap: 6px; &::before { content: "→"; font-size: 14px; color: #3b82f6; } `;
// const NoData = styled.p` text-align: center; color: #6b7280; font-style: italic; padding: 60px 20px; font-size: 15.5px; `;

// const ReadOnlyText = styled.div`
//   width: 100%; min-height: 60px; padding: 14px; font-size: 14px; line-height: 1.6;
//   background: #f8fafc; color: #334155; border-radius: 12px; border: 1px solid #e2e8f0;
//   white-space: pre-wrap;
// `;

// const EmptyStateText = styled(ReadOnlyText)`
//   color: #94a3b8; font-style: italic; background: #fdfdfd; border: 1px dashed #cbd5e1;
// `;

// /* 🔥 NEW: Comment Thread Styles */
// const CommentThread = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 8px;
//   margin-bottom: 12px;
// `;

// const CommentBubble = styled.div`
//   background: #f8fafc;
//   padding: 10px 14px;
//   border-radius: 8px;
//   font-size: 13px;
//   border: 1px solid #e2e8f0;
//   color: #334155;
//   white-space: pre-wrap;
// `;

// const CommentAuthor = styled.strong`
//   color: #1e40af;
//   display: block;
//   margin-bottom: 4px;
// `;

// const FieldTextarea = styled.textarea` 
//   width: 100%; min-height: 80px; border: 1px solid #fcd34d; border-radius: 10px; padding: 12px; 
//   font-size: 14px; resize: vertical; box-sizing: border-box; transition: all 0.2s;
//   background: #fffbeb; color: #1f2937; margin-bottom: 8px;
//   &:focus { border-color: #d97706; box-shadow: 0 0 0 4px rgba(217, 119, 6, 0.12); outline: none; } 
// `;

// const SendButton = styled.button` 
//   background: #d97706; color: white; border: none; padding: 10px 16px; border-radius: 8px; 
//   font-weight: 700; cursor: pointer; font-size: 13px; width: 100%; transition: all 0.2s;
//   &:disabled { opacity: 0.6; cursor: not-allowed; } 
//   &:hover:not(:disabled) { background: #b45309; } 
// `;

// const InlineMessage = styled.div`
//   font-size: 12px;
//   font-weight: 700;
//   padding: 8px 10px;
//   border-radius: 8px;
//   margin-bottom: 8px;
//   text-align: center;
//   background: ${({ type }) => type === 'success' ? 'rgba(22, 163, 74, 0.1)' : 'rgba(220, 38, 38, 0.1)'};
//   color: ${({ type }) => type === 'success' ? '#16a34a' : '#dc2626'};
//   border: 1px solid ${({ type }) => type === 'success' ? 'rgba(22, 163, 74, 0.2)' : 'rgba(220, 38, 38, 0.2)'};
// `;

// /* ================= RESPONSIVE GOAL CARDS ================= */
// const GoalsMobileGrid = styled.div` display: none; @media (max-width: 900px) { display: grid; gap: 16px; } `;
// const GoalCard = styled.div` background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%); border: 1px solid rgba(148, 163, 184, 0.18); border-left: 5px solid ${({ variant }) => (variant === "routine" ? "#ea580c" : "#3b82f6")}; border-radius: 22px; padding: 18px; box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06); position: relative; `;
// const GoalCardHeader = styled.div` display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; flex-wrap: wrap; margin-bottom: 14px; `;
// const Pill = styled.div` display: inline-flex; align-items: center; padding: 8px 12px; border-radius: 999px; font-size: 12px; font-weight: 800; letter-spacing: 0.04em; text-transform: uppercase; background: ${({ variant }) => variant === "routine" ? "rgba(234, 88, 12, 0.12)" : "rgba(37,99,235,0.12)"}; color: ${({ variant }) => (variant === "routine" ? "#ea580c" : "#1d4ed8")}; `;
// const GoalCardTitle = styled.div` font-size: 1rem; font-weight: 800; line-height: 1.5; color: #0f172a; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; white-space: normal; `;
// const GoalCardMeta = styled.div` margin-top: 6px; font-size: 14px; color: #64748b; line-height: 1.5; `;
// const SmallLabel = styled.div` font-size: 12px; font-weight: 800; color: #64748b; margin: 14px 0 6px; text-transform: uppercase; letter-spacing: 0.04em; `;
// const EmptyCard = styled.div` padding: 28px 20px; text-align: center; border-radius: 18px; background: #f8fafc; border: 1px dashed #cbd5e1; color: #64748b; `;

// /* ================= PAGINATION ================= */
// const PaginationContainer = styled.div` display: flex; justify-content: center; align-items: center; gap: 12px; margin-top: 28px; flex-wrap: wrap; `;
// const PageButton = styled.button` padding: 10px 18px; border: 1px solid #cbd5e1; background: white; border-radius: 9999px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; &:hover:not(:disabled) { background: #f1f5f9; transform: translateY(-1px); color: #1e40af; } &:disabled { opacity: 0.5; cursor: not-allowed; } &.active { background: #1e40af; color: white; border-color: #1e40af; } `;

// /* ================= STATES ================= */
// const StateBox = styled.div`
//   text-align: center; padding: 50px 20px; border-radius: 18px;
//   background: ${({ type }) => type === 'error' ? '#fef2f2' : '#ffffff'};
//   color: ${({ type }) => type === 'error' ? '#dc2626' : '#64748b'};
//   border: 1px solid ${({ type }) => type === 'error' ? '#fecaca' : '#e2e8f0'};
//   font-size: 1rem;
// `;

// const Spinner = styled.div`
//   width: 40px; height: 40px; margin: 0 auto 16px; border-radius: 50%;
//   border: 4px solid #e0ecff; border-top-color: #1d4ed8; animation: spin 0.8s linear infinite;
//   @keyframes spin { to { transform: rotate(360deg); } }
// `;

// /* ================= COMPONENT ================= */
// const SuperAdminStaffGoals = ({ user }) => {
//   const { userId } = useParams();
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [staffInfo, setStaffInfo] = useState(null);

//   const [editValues, setEditValues] = useState({});
//   const [updatingId, setUpdatingId] = useState(null);
//   const [feedbackStatus, setFeedbackStatus] = useState({}); 

//   const availableMonths = useMemo(() => generateMonthOptions(), []);
  
//   const [selectedMonth, setSelectedMonth] = useState(
//     localStorage.getItem("superAdminViewMonth") || getCurrentMonthName()
//   );

//   const [submittedGoals, setSubmittedGoals] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);

//   useEffect(() => {
//     localStorage.setItem("superAdminViewMonth", selectedMonth);
//   }, [selectedMonth]);

//   useEffect(() => {
//     const fetchStaffGoals = async () => {
//       try {
//         setLoading(true);
//         setError(null);
        
//         const targetMonthParam = formatToYearMonth(selectedMonth);
//         const res = await api.get(`/goals/admin/user-month/${userId}?targetMonth=${targetMonthParam}`);
        
//         setSubmittedGoals(res.data.data || []);
//         if (res.data.staff) setStaffInfo(res.data.staff);
        
//       } catch (err) {
//         console.error(err);
//         setError(err.response?.data?.message || 'Failed to fetch staff goals');
//         setSubmittedGoals([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (userId) fetchStaffGoals();
//   }, [userId, selectedMonth]);

//   const monthlyGoals = submittedGoals.filter((g) => g.type === "monthly");
//   const weeklyGoals = submittedGoals.filter((g) => g.type === "weekly");
//   const routineGoals = submittedGoals.filter((g) => g.type === "routine");

//   const descendingWeeklyGoals = [...weeklyGoals].sort((a, b) => new Date(b.weeklyDeliveryDate).getTime() - new Date(a.weeklyDeliveryDate).getTime());
//   const weeks = [...new Set(descendingWeeklyGoals.map((w) => getWeekLabel(w.weeklyDeliveryDate)))];
//   const maxPages = Math.max(weeks.length, 1);
//   const displayWeek = weeks[currentPage - 1] || getWeekLabel(new Date());
  
//   const filteredWeeklies = weeklyGoals.filter((w) => getWeekLabel(w.weeklyDeliveryDate) === displayWeek);

//   const renderReadOnlyField = (content, placeholder) => {
//     if (!content || !content.trim()) {
//       return <EmptyStateText>{placeholder}</EmptyStateText>;
//     }
//     return <ReadOnlyText>{content}</ReadOnlyText>;
//   };

//   const handleEditChange = (id, field, value) => {
//     setEditValues((prev) => ({
//       ...prev,
//       [`${id}_${field}`]: value,
//     }));
//   };

//   const saveFeedback = async (goalId) => {
//     const newComment = editValues[`${goalId}_sup`];

//     // Block submission if field is empty
//     if (!newComment || !newComment.trim()) return;

//     setUpdatingId(goalId);
//     setFeedbackStatus((prev) => ({ ...prev, [goalId]: null }));

//     try {
//       const res = await api.put(`/goals/super-admin-comment/${goalId}`, { comment: newComment });
      
//       // Update local state instantly with the fresh array returned from backend
//       setSubmittedGoals((prevGoals) => 
//         prevGoals.map((g) => g._id === goalId ? res.data.goal : g)
//       );

//       // Clear out the textarea completely
//       setEditValues((prev) => ({ ...prev, [`${goalId}_sup`]: "" }));

//       setFeedbackStatus((prev) => ({
//         ...prev,
//         [goalId]: { type: "success", text: "Sent to staff!" }
//       }));

//       setTimeout(() => {
//         setFeedbackStatus((prev) => ({ ...prev, [goalId]: null }));
//       }, 3000);

//     } catch (err) {
//       console.error(err);
//       setFeedbackStatus((prev) => ({
//         ...prev,
//         [goalId]: { type: "error", text: "Failed to send" }
//       }));
//     } finally {
//       setUpdatingId(null);
//     }
//   };

//   return (
//     <Container>
//       <NavBarSuper user={user} />

//       <PageWrapper>
//         <HeaderSection>
//           <BackButton onClick={() => navigate('/super-admin/dashboard')}>
//             <FaArrowLeft /> Back to Directory
//           </BackButton>
//         </HeaderSection>

//         <HeroCard>
//           <div>
//             <HeroTitle>Staff Goal Review</HeroTitle>
//             <HeroText>
//               Reviewing the submitted goals, achievements, and comments for <strong>{staffInfo?.firstName || 'this staff member'}</strong>. Send feedback directly to their dashboard.
//             </HeroText>
//           </div>
//         </HeroCard>

//         <Card>
//           <TitleRow>
//             <SectionTitle>Viewing Goals for</SectionTitle>
//             <GlobalMonthSelect value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
//               {availableMonths.map(m => (
//                 <option key={m} value={m}>{m}</option>
//               ))}
//             </GlobalMonthSelect>
//           </TitleRow>

//           <Subtitle>
//             Read their achievements and send weekly/routine feedback directly below. To formally score these, return to the dashboard and open their Appraisal Submission.
//           </Subtitle>

//           {loading ? (
//             <StateBox>
//               <Spinner />
//               Loading staff records...
//             </StateBox>
//           ) : error ? (
//             <StateBox type="error">{error}</StateBox>
//           ) : (
//             <>
//               {/* DESKTOP TABLE */}
//               <GoalsTableContainer>
//                 <GoalsTable>
//                   <thead>
//                     <tr>
//                       <Th style={{ width: "31%" }}>Goals</Th>
//                       <Th style={{ width: "23%" }}>Achievements</Th>
//                       <Th style={{ width: "23%" }}>Comments</Th>
//                       <Th style={{ width: "23%" }}>Admin Feedback</Th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {submittedGoals.length > 0 ? (
//                       <>
//                         {monthlyGoals.map((month) => (
//                           <React.Fragment key={month._id}>
//                             <MonthlyTr>
//                               <Td style={{ background: "#f0f9ff", borderLeft: "6px solid #3b82f6" }}>
//                                 <MonthlyBlock>
//                                   <MonthlyTag>Monthly Goal</MonthlyTag>
//                                   <div style={{ marginTop: "6px", marginBottom: "4px" }}>
//                                     <UnitBadge>{getGoalUnit(month)}</UnitBadge>
//                                   </div>
//                                   <GoalText>{month.goal}</GoalText>
//                                   <GoalMeta>{formatNiceDate(month.startDate)} — {formatNiceDate(month.deliveryDate)}</GoalMeta>
//                                 </MonthlyBlock>
//                               </Td>
//                               <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
//                               <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
//                               <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
//                             </MonthlyTr>

//                             {filteredWeeklies.filter((w) => w.parentMonthlyGoal === month._id).map((week) => (
//                               <WeeklyTr key={week._id}>
//                                 <Td>
//                                   <WeeklyGoalWrap>
//                                     <WeeklyTitle>{getWeekLabel(week.weeklyDeliveryDate)} Goal</WeeklyTitle>
//                                     <GoalText>{week.goal}</GoalText>
//                                     <GoalMeta>Due {formatNiceDate(week.weeklyDeliveryDate)}</GoalMeta>
//                                   </WeeklyGoalWrap>
//                                 </Td>
//                                 <Td>
//                                   {renderReadOnlyField(week.achievements, "No achievements submitted.")}
//                                 </Td>
//                                 <Td>
//                                   {renderReadOnlyField(week.comments, "No comments added.")}
//                                 </Td>
//                                 <Td>
//                                   {/* Thread History Display */}
//                                   {Array.isArray(week.superAdminComments) && week.superAdminComments.length > 0 && (
//                                     <CommentThread>
//                                       {week.superAdminComments.map((c, idx) => (
//                                         <CommentBubble key={idx}>
//                                           <CommentAuthor>{c.authorUsername}</CommentAuthor>
//                                           {c.text}
//                                         </CommentBubble>
//                                       ))}
//                                     </CommentThread>
//                                   )}
                                  
//                                   {/* Feedback Status Indicator */}
//                                   {feedbackStatus[week._id] && (
//                                     <InlineMessage type={feedbackStatus[week._id].type}>
//                                       {feedbackStatus[week._id].text}
//                                     </InlineMessage>
//                                   )}
                                  
//                                   {/* Blank Textarea for New Feedback */}
//                                   <FieldTextarea
//                                     value={editValues[`${week._id}_sup`] ?? week.superAdminComments?.text ?? ""} 
//                                     onChange={(e) => handleEditChange(week._id, "sup", e.target.value)}
//                                     placeholder="Type new feedback for this week..."
//                                   />
//                                   <SendButton
//                                     onClick={() => saveFeedback(week._id)}
//                                     disabled={updatingId === week._id}
//                                   >
//                                     {updatingId === week._id ? "Sending..." : "Send to Staff"}
//                                   </SendButton>
//                                 </Td>
//                               </WeeklyTr>
//                             ))}
//                           </React.Fragment>
//                         ))}

//                         {routineGoals.map((routine) => (
//                           <tr key={routine._id}>
//                             <Td style={{ borderLeft: "6px solid #ea580c" }}>
//                               <MonthlyBlock>
//                                 <RoutineTag>Other Goal</RoutineTag>
//                                 <GoalText>{routine.goal}</GoalText>
//                                 <GoalMeta>Due {formatNiceDate(routine.deliveryDate)}</GoalMeta>
//                               </MonthlyBlock>
//                             </Td>
//                             <Td>
//                               {renderReadOnlyField(routine.achievements, "No achievements submitted.")}
//                             </Td>
//                             <Td>
//                               {renderReadOnlyField(routine.comments, "No comments added.")}
//                             </Td>
//                             <Td>
//                               {/* Thread History Display */}
//                               {Array.isArray(routine.superAdminComments) && routine.superAdminComments.length > 0 && (
//                                 <CommentThread>
//                                   {routine.superAdminComments.map((c, idx) => (
//                                     <CommentBubble key={idx}>
//                                       <CommentAuthor>{c.authorUsername}</CommentAuthor>
//                                       {c.text}
//                                     </CommentBubble>
//                                   ))}
//                                 </CommentThread>
//                               )}

//                               {feedbackStatus[routine._id] && (
//                                 <InlineMessage type={feedbackStatus[routine._id].type}>
//                                   {feedbackStatus[routine._id].text}
//                                 </InlineMessage>
//                               )}
                              
//                               <FieldTextarea
//                                 value={editValues[`${routine._id}_sup`] ?? routine.superAdminComments?.text ?? ""} 
//                                 onChange={(e) => handleEditChange(routine._id, "sup", e.target.value)}
//                                 placeholder="Type new feedback for this routine goal..."
//                               />
//                               <SendButton
//                                 onClick={() => saveFeedback(routine._id)}
//                                 disabled={updatingId === routine._id}
//                               >
//                                 {updatingId === routine._id ? "Sending..." : "Send to Staff"}
//                               </SendButton>
//                             </Td>
//                           </tr>
//                         ))}
//                       </>
//                     ) : (
//                       <tr>
//                         <Td colSpan="4"><NoData>No goals submitted yet for this month.</NoData></Td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </GoalsTable>
//               </GoalsTableContainer>

//               {/* MOBILE LAYOUT */}
//               <GoalsMobileGrid>
//                 {submittedGoals.length > 0 ? (
//                   <>
//                     {monthlyGoals.map((month) => (
//                       <React.Fragment key={month._id}>
//                         <GoalCard>
//                           <GoalCardHeader><Pill>Monthly Goal</Pill></GoalCardHeader>
//                           <div style={{ marginBottom: "10px" }}><UnitBadge>{getGoalUnit(month)}</UnitBadge></div>
//                           <GoalCardTitle>{month.goal}</GoalCardTitle>
//                           <GoalCardMeta>{formatNiceDate(month.startDate)} — {formatNiceDate(month.deliveryDate)}</GoalCardMeta>
//                         </GoalCard>

//                         {filteredWeeklies.filter((w) => w.parentMonthlyGoal === month._id).map((week) => (
//                           <GoalCard key={week._id}>
//                             <GoalCardHeader>
//                               <WeeklyTitle>{getWeekLabel(week.weeklyDeliveryDate)}</WeeklyTitle>
//                               <Pill>Weekly</Pill>
//                             </GoalCardHeader>
//                             <GoalCardTitle>{week.goal}</GoalCardTitle>
//                             <GoalCardMeta>Due {formatNiceDate(week.weeklyDeliveryDate)}</GoalCardMeta>
                            
//                             <SmallLabel>Achievements</SmallLabel>
//                             {renderReadOnlyField(week.achievements, "No achievements submitted.")}
                            
//                             <SmallLabel>Comments</SmallLabel>
//                             {renderReadOnlyField(week.comments, "No comments added.")}

//                             <SmallLabel>Admin Feedback</SmallLabel>
                            
//                             {/* Thread History Display */}
//                             {Array.isArray(week.superAdminComments) && week.superAdminComments.length > 0 && (
//                               <CommentThread>
//                                 {week.superAdminComments.map((c, idx) => (
//                                   <CommentBubble key={idx}>
//                                     <CommentAuthor>{c.authorUsername}</CommentAuthor>
//                                     {c.text}
//                                   </CommentBubble>
//                                 ))}
//                               </CommentThread>
//                             )}

//                             {feedbackStatus[week._id] && (
//                               <InlineMessage type={feedbackStatus[week._id].type}>
//                                 {feedbackStatus[week._id].text}
//                               </InlineMessage>
//                             )}
//                             <FieldTextarea
//                               value={editValues[`${week._id}_sup`] ?? week.superAdminComments?.text ?? ""} 
//                               onChange={(e) => handleEditChange(week._id, "sup", e.target.value)}
//                               placeholder="Type new feedback for this week..."
//                             />
//                             <SendButton
//                               onClick={() => saveFeedback(week._id)}
//                               disabled={updatingId === week._id}
//                             >
//                               {updatingId === week._id ? "Sending..." : "Send to Staff"}
//                             </SendButton>
//                           </GoalCard>
//                         ))}
//                       </React.Fragment>
//                     ))}

//                     {routineGoals.map((routine) => (
//                       <GoalCard key={routine._id} variant="routine">
//                         <GoalCardHeader><Pill variant="routine">Other Goal</Pill></GoalCardHeader>
//                         <GoalCardTitle>{routine.goal}</GoalCardTitle>
//                         <GoalCardMeta>Due {formatNiceDate(routine.deliveryDate)}</GoalCardMeta>
                        
//                         <SmallLabel>Achievements</SmallLabel>
//                         {renderReadOnlyField(routine.achievements, "No achievements submitted.")}
                        
//                         <SmallLabel>Comments</SmallLabel>
//                         {renderReadOnlyField(routine.comments, "No comments added.")}

//                         <SmallLabel>Admin Feedback</SmallLabel>
                        
//                         {/* Thread History Display */}
//                         {Array.isArray(routine.superAdminComments) && routine.superAdminComments.length > 0 && (
//                           <CommentThread>
//                             {routine.superAdminComments.map((c, idx) => (
//                               <CommentBubble key={idx}>
//                                 <CommentAuthor>{c.authorUsername}</CommentAuthor>
//                                 {c.text}
//                               </CommentBubble>
//                             ))}
//                           </CommentThread>
//                         )}

//                         {feedbackStatus[routine._id] && (
//                           <InlineMessage type={feedbackStatus[routine._id].type}>
//                             {feedbackStatus[routine._id].text}
//                           </InlineMessage>
//                         )}
//                         <FieldTextarea
//                           value={editValues[`${routine._id}_sup`] ?? routine.superAdminComments?.text ?? ""}
//                           onChange={(e) => handleEditChange(routine._id, "sup", e.target.value)}
//                           placeholder="Type new feedback for this routine goal..."
//                         />
//                         <SendButton
//                           onClick={() => saveFeedback(routine._id)}
//                           disabled={updatingId === routine._id}
//                         >
//                           {updatingId === routine._id ? "Sending..." : "Send to Staff"}
//                         </SendButton>
//                       </GoalCard>
//                     ))}
//                   </>
//                 ) : (
//                   <EmptyCard>No goals submitted yet for this month.</EmptyCard>
//                 )}
//               </GoalsMobileGrid>

//               <PaginationContainer>
//                 {weeks.map((weekLabel, i) => (
//                   <PageButton
//                     key={i} className={currentPage === i + 1 ? "active" : ""} onClick={() => setCurrentPage(i + 1)} type="button"
//                   >
//                     {weekLabel}
//                   </PageButton>
//                 ))}
//               </PaginationContainer>
//             </>
//           )}
//         </Card>
//       </PageWrapper>
//       <Footer />
//     </Container>
//   );
// };

// export default SuperAdminStaffGoals;









import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { useParams, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import NavBarSuper from "./NavBarSuper";
import Footer from "./Footer";
import api from "../api";

/* ================= HELPERS ================= */
const getCurrentMonthName = () => {
  const date = new Date();
  return date.toLocaleString("default", { month: "long", year: "numeric" });
};

const generateMonthOptions = () => {
  const months = [];
  const date = new Date();
  date.setMonth(date.getMonth() - 3); 
  for (let i = 0; i < 12; i++) {
    months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
    date.setMonth(date.getMonth() + 1);
  }
  return months;
};

const formatToYearMonth = (periodString) => {
  if (!periodString) return "";
  const d = new Date(periodString);
  if (isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  return `${y}-${m}`;
};

const getWeekLabel = (dateInput) => {
  if (!dateInput) return "Unknown Week";
  let date;
  if (dateInput instanceof Date) {
    date = dateInput;
  } else if (typeof dateInput === 'string') {
    const datePart = dateInput.includes('T') ? dateInput.split('T')[0] : dateInput;
    const parts = datePart.split('-'); 
    if (parts.length !== 3) return "Invalid Date";
    date = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
  } else {
    return "Invalid Date";
  }
  if (isNaN(date.getTime())) return "Invalid Date";
  const sunday = new Date(date);
  sunday.setDate(date.getDate() - date.getDay());
  const saturday = new Date(sunday);
  saturday.setDate(sunday.getDate() + 6);
  const getWeekNum = (d) => {
    const firstDay = new Date(d.getFullYear(), d.getMonth(), 1).getDay();
    return Math.ceil((d.getDate() + firstDay) / 7);
  };
  if (sunday.getMonth() === saturday.getMonth()) {
    return `Week ${getWeekNum(saturday)}`;
  } else {
    const nextMonthName = saturday.toLocaleString("default", { month: "long" });
    return `Week ${getWeekNum(sunday)} / ${nextMonthName} Week ${getWeekNum(saturday)}`;
  }
};

const formatNiceDate = (dateString) => {
  if (!dateString) return "—";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid date";
  const month = date.toLocaleString("default", { month: "long" });
  const day = date.getDate();
  const year = date.getFullYear();
  let suffix = "th";
  if (day % 10 === 1 && day % 100 !== 11) suffix = "st";
  else if (day % 10 === 2 && day % 100 !== 12) suffix = "nd";
  else if (day % 10 === 3 && day % 100 !== 13) suffix = "rd";
  return `${month} ${day}${suffix}, ${year}`;
};

const getGoalUnit = (goal) => {
  let unitVal = goal.unit || goal.subDepartment || "";
  if (typeof unitVal !== 'string') {
    unitVal = String(unitVal);
  }
  return unitVal;
};

/* ================= SHARED COMPONENTS ================= */
const ExpandableText = ({ text, limit = 90, isWeekly = false }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  if (!text) return null;

  const textStyle = {
    maxWidth: "350px",
    wordWrap: "break-word",
    marginTop: isWeekly ? "4px" : "10px",
    fontWeight: isWeekly ? "600" : "700",
    color: "#0f172a",
    fontSize: isWeekly ? "13px" : "14px",
    lineHeight: "1.5",
  };

  if (String(text).length <= limit) {
    return <div style={textStyle}>{text}</div>;
  }

  return (
    <div style={{ ...textStyle, display: "block" }}>
      <span style={{ display: "inline" }}>
        {isExpanded ? text : `${String(text).substring(0, limit)}...`}
      </span>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          setIsExpanded(!isExpanded);
        }}
        style={{
          background: "none", border: "none", color: "#2563eb",
          cursor: "pointer", fontSize: "12px", fontWeight: "800",
          padding: "0 0 0 6px", textDecoration: "underline",
        }}
      >
        {isExpanded ? "Show less" : "Read more"}
      </button>
    </div>
  );
};

/* ================= PAGE LAYOUT ================= */
const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
`;

const PageWrapper = styled.div`
  flex: 1 0 auto;
  width: min(1380px, calc(100% - 32px));
  margin: 90px auto 40px;

  @media (max-width: 768px) {
    width: min(100%, calc(100% - 20px));
    margin-top: 80px;
  }
`;

const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
`;

const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: #1d4ed8;
  font-weight: 800;
  font-size: 1rem;
  cursor: pointer;
  transition: transform 0.2s ease;
  padding: 0;

  &:hover {
    transform: translateX(-4px);
  }
`;

const HeroCard = styled.div`
  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #1d4ed8 100%);
  color: #fff;
  border-radius: 24px;
  padding: 32px;
  margin-bottom: 24px;
  box-shadow: 0 15px 35px rgba(15, 23, 42, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
`;

const HeroTitle = styled.h1`
  margin: 0 0 10px;
  font-size: clamp(1.6rem, 1.2rem + 1.2vw, 2.4rem);
  font-weight: 800;
`;

const HeroText = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.86);
  font-size: 1.05rem;
  max-width: 800px;
  line-height: 1.5;
`;

/* ================= CARDS / TABLES ================= */
const Card = styled.div`
  background: rgba(255, 255, 255, 0.96);
  border-radius: 28px;
  padding: 24px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.16);
  margin-bottom: 34px;

  @media (max-width: 768px) { padding: 18px; border-radius: 22px; }
`;

const TitleRow = styled.div`
  display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 10px;
`;

const SectionTitle = styled.h2`
  font-size: clamp(1.15rem, 1rem + 0.6vw, 1.5rem); color: #1f2937; margin: 0; font-weight: 800;
`;

const GlobalMonthSelect = styled.select`
  padding: 6px 16px; border-radius: 12px; border: 2px solid #bfdbfe; font-size: 1.1rem;
  font-weight: 800; color: #1d4ed8; background: #eff6ff; outline: none; cursor: pointer; transition: all 0.2s;
  &:focus { border-color: #3b82f6; box-shadow: 0 0 0 4px rgba(59,130,246,0.1); }
`;

const Subtitle = styled.p` color: #6b7280; margin: 0 0 24px; font-size: 0.98rem; line-height: 1.6; `;

/* ================= BADGES ================= */
const UnitBadge = styled.span`
  display: inline-block; padding: 5px 10px; background: #e0f2fe; color: #0369a1; border: 1px solid #bae6fd;
  border-radius: 6px; font-size: 11px; font-weight: 800; letter-spacing: 0.05em; text-transform: uppercase;
`;

/* ================= GOALS TABLE DESKTOP ================= */
const GoalsTableContainer = styled.div`
  border-radius: 18px; border: 1px solid #e2e8f0; background: white; width: 100%; overflow: hidden;
  @media (max-width: 900px) { display: none; }
`;

const GoalsTable = styled.table` width: 100%; border-collapse: collapse; background: white; table-layout: fixed; `;
const Th = styled.th` background: #f8fafc; padding: 18px 20px; text-align: left; font-weight: 700; color: #1e293b; border-bottom: 2px solid #e2e8f0; font-size: 14px; `;
const Td = styled.td` padding: 18px 20px; border-bottom: 1px solid #f1f5f9; color: #1f2937; font-size: 15px; vertical-align: top; white-space: normal; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; max-width: 0; `;
const MonthlyTr = styled.tr` background: #f0f9ff; `;
const WeeklyTr = styled.tr` background: #fff; `;
const MonthlyBlock = styled.div` padding: 8px 0; `;
const MonthlyTag = styled.div` color: #1e40af; font-size: 13px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; `;
const RoutineTag = styled(MonthlyTag)` color: #ea580c; `;
const GoalText = styled.div` margin-top: 10px; font-weight: 700; font-size: 16px; line-height: 1.5; color: #0f172a; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; white-space: normal; width: 100%; `;
const GoalMeta = styled.div` margin-top: 6px; color: #2563eb; font-size: 14px; font-weight: 700; line-height: 1.5; `;
const WeeklyGoalWrap = styled.div` display: grid; gap: 6px; min-width: 0; position: relative; padding-left: 16px; border-left: 2px solid #cbd5f5; &::before { content: ""; position: absolute; left: -6px; top: 16px; width: 10px; height: 2px; background: #3b82f6; } `;
const WeeklyTitle = styled.div` font-weight: 800; font-size: 12px; color: #1d4ed8; text-transform: uppercase; letter-spacing: 0.04em; display: flex; align-items: center; gap: 6px; &::before { content: "→"; font-size: 14px; color: #3b82f6; } `;
const NoData = styled.p` text-align: center; color: #6b7280; font-style: italic; padding: 60px 20px; font-size: 15.5px; `;

const ReadOnlyText = styled.div`
  width: 100%; min-height: 60px; padding: 14px; font-size: 14px; line-height: 1.6;
  background: #f8fafc; color: #334155; border-radius: 12px; border: 1px solid #e2e8f0;
  white-space: pre-wrap;
`;

const EmptyStateText = styled(ReadOnlyText)`
  color: #94a3b8; font-style: italic; background: #fdfdfd; border: 1px dashed #cbd5e1;
`;

const FieldTextarea = styled.textarea` 
  width: 100%; min-height: 80px; border: 1px solid #fcd34d; border-radius: 10px; padding: 12px; 
  font-size: 14px; resize: vertical; box-sizing: border-box; transition: all 0.2s;
  background: #fffbeb; color: #1f2937; margin-bottom: 8px;
  &:focus { border-color: #d97706; box-shadow: 0 0 0 4px rgba(217, 119, 6, 0.12); outline: none; } 
`;

const SendButton = styled.button` 
  background: #d97706; color: white; border: none; padding: 10px 16px; border-radius: 8px; 
  font-weight: 700; cursor: pointer; font-size: 13px; width: 100%; transition: all 0.2s;
  &:disabled { opacity: 0.6; cursor: not-allowed; } 
  &:hover:not(:disabled) { background: #b45309; } 
`;

const InlineMessage = styled.div`
  font-size: 12px;
  font-weight: 700;
  padding: 8px 10px;
  border-radius: 8px;
  margin-bottom: 8px;
  text-align: center;
  background: ${({ type }) => type === 'success' ? 'rgba(22, 163, 74, 0.1)' : 'rgba(220, 38, 38, 0.1)'};
  color: ${({ type }) => type === 'success' ? '#16a34a' : '#dc2626'};
  border: 1px solid ${({ type }) => type === 'success' ? 'rgba(22, 163, 74, 0.2)' : 'rgba(220, 38, 38, 0.2)'};
`;

/* ================= RESPONSIVE GOAL CARDS ================= */
const GoalsMobileGrid = styled.div` display: none; @media (max-width: 900px) { display: grid; gap: 16px; } `;
const GoalCard = styled.div` background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%); border: 1px solid rgba(148, 163, 184, 0.18); border-left: 5px solid ${({ variant }) => (variant === "routine" ? "#ea580c" : "#3b82f6")}; border-radius: 22px; padding: 18px; box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06); position: relative; `;
const GoalCardHeader = styled.div` display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; flex-wrap: wrap; margin-bottom: 14px; `;
const Pill = styled.div` display: inline-flex; align-items: center; padding: 8px 12px; border-radius: 999px; font-size: 12px; font-weight: 800; letter-spacing: 0.04em; text-transform: uppercase; background: ${({ variant }) => variant === "routine" ? "rgba(234, 88, 12, 0.12)" : "rgba(37,99,235,0.12)"}; color: ${({ variant }) => (variant === "routine" ? "#ea580c" : "#1d4ed8")}; `;
const GoalCardTitle = styled.div` font-size: 1rem; font-weight: 800; line-height: 1.5; color: #0f172a; overflow-wrap: anywhere; word-wrap: break-word; word-break: break-word; white-space: normal; `;
const GoalCardMeta = styled.div` margin-top: 6px; font-size: 14px; color: #64748b; line-height: 1.5; `;
const SmallLabel = styled.div` font-size: 12px; font-weight: 800; color: #64748b; margin: 14px 0 6px; text-transform: uppercase; letter-spacing: 0.04em; `;
const EmptyCard = styled.div` padding: 28px 20px; text-align: center; border-radius: 18px; background: #f8fafc; border: 1px dashed #cbd5e1; color: #64748b; `;

/* ================= PAGINATION ================= */
const PaginationContainer = styled.div` display: flex; justify-content: center; align-items: center; gap: 12px; margin-top: 28px; flex-wrap: wrap; `;
const PageButton = styled.button` padding: 10px 18px; border: 1px solid #cbd5e1; background: white; border-radius: 9999px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; &:hover:not(:disabled) { background: #f1f5f9; transform: translateY(-1px); color: #1e40af; } &:disabled { opacity: 0.5; cursor: not-allowed; } &.active { background: #1e40af; color: white; border-color: #1e40af; } `;

/* ================= STATES ================= */
const StateBox = styled.div`
  text-align: center; padding: 50px 20px; border-radius: 18px;
  background: ${({ type }) => type === 'error' ? '#fef2f2' : '#ffffff'};
  color: ${({ type }) => type === 'error' ? '#dc2626' : '#64748b'};
  border: 1px solid ${({ type }) => type === 'error' ? '#fecaca' : '#e2e8f0'};
  font-size: 1rem;
`;

const Spinner = styled.div`
  width: 40px; height: 40px; margin: 0 auto 16px; border-radius: 50%;
  border: 4px solid #e0ecff; border-top-color: #1d4ed8; animation: spin 0.8s linear infinite;
  @keyframes spin { to { transform: rotate(360deg); } }
`;

/* ================= COMPONENT ================= */
const SuperAdminStaffGoals = ({ user }) => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [staffInfo, setStaffInfo] = useState(null);

  const [editValues, setEditValues] = useState({});
  const [updatingId, setUpdatingId] = useState(null);
  const [feedbackStatus, setFeedbackStatus] = useState({}); 

  const availableMonths = useMemo(() => generateMonthOptions(), []);
  
  const [selectedMonth, setSelectedMonth] = useState(
    localStorage.getItem("superAdminViewMonth") || getCurrentMonthName()
  );

  const [submittedGoals, setSubmittedGoals] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    localStorage.setItem("superAdminViewMonth", selectedMonth);
  }, [selectedMonth]);

  useEffect(() => {
    const fetchStaffGoals = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const targetMonthParam = formatToYearMonth(selectedMonth);
        const res = await api.get(`/goals/admin/user-month/${userId}?targetMonth=${targetMonthParam}`);
        
        setSubmittedGoals(res.data.data || []);
        if (res.data.staff) setStaffInfo(res.data.staff);
        
      } catch (err) {
        console.error(err);
        setError(err.response?.data?.message || 'Failed to fetch staff goals');
        setSubmittedGoals([]);
      } finally {
        setLoading(false);
      }
    };

    if (userId) fetchStaffGoals();
  }, [userId, selectedMonth]);

  const monthlyGoals = submittedGoals.filter((g) => g.type === "monthly");
  const weeklyGoals = submittedGoals.filter((g) => g.type === "weekly");
  const routineGoals = submittedGoals.filter((g) => g.type === "routine");

  const descendingWeeklyGoals = [...weeklyGoals].sort((a, b) => new Date(b.weeklyDeliveryDate).getTime() - new Date(a.weeklyDeliveryDate).getTime());
  const weeks = [...new Set(descendingWeeklyGoals.map((w) => getWeekLabel(w.weeklyDeliveryDate)))];
  const maxPages = Math.max(weeks.length, 1);
  const displayWeek = weeks[currentPage - 1] || getWeekLabel(new Date());
  
  const filteredWeeklies = weeklyGoals.filter((w) => getWeekLabel(w.weeklyDeliveryDate) === displayWeek);

  const renderReadOnlyField = (content, placeholder) => {
    if (!content || !content.trim()) {
      return <EmptyStateText>{placeholder}</EmptyStateText>;
    }
    return <ReadOnlyText>{content}</ReadOnlyText>;
  };

  const handleEditChange = (id, field, value) => {
    setEditValues((prev) => ({
      ...prev,
      [`${id}_${field}`]: value,
    }));
  };

  const saveFeedback = async (goalId) => {
    const newComment = editValues[`${goalId}_sup`];

    if (!newComment || !newComment.trim()) return;

    setUpdatingId(goalId);
    setFeedbackStatus((prev) => ({ ...prev, [goalId]: null }));

    try {
      const res = await api.put(`/goals/super-admin-comment/${goalId}`, { comment: newComment });
      
      // Update local goals state instantly with the fresh data returned from the backend
      setSubmittedGoals((prevGoals) => 
        prevGoals.map((g) => g._id === goalId ? res.data.goal : g)
      );

      // Delete the temporary edit value, allowing the input to automatically 
      // fallback to the fresh updated data from the state we just set above
      setEditValues((prev) => {
        const newVals = { ...prev };
        delete newVals[`${goalId}_sup`];
        return newVals;
      });

      setFeedbackStatus((prev) => ({
        ...prev,
        [goalId]: { type: "success", text: "Sent to staff!" }
      }));

      setTimeout(() => {
        setFeedbackStatus((prev) => ({ ...prev, [goalId]: null }));
      }, 3000);

    } catch (err) {
      console.error(err);
      setFeedbackStatus((prev) => ({
        ...prev,
        [goalId]: { type: "error", text: "Failed to send" }
      }));
    } finally {
      setUpdatingId(null);
    }
  };

  return (
    <Container>
      <NavBarSuper user={user} />

      <PageWrapper>
        <HeaderSection>
          <BackButton onClick={() => navigate('/super-admin/dashboard')}>
            <FaArrowLeft /> Back to Directory
          </BackButton>
        </HeaderSection>

        <HeroCard>
          <div>
            <HeroTitle>Staff Goal Review</HeroTitle>
            <HeroText>
              Reviewing the submitted goals, achievements, and comments for <strong>{staffInfo?.firstName || 'this staff member'}</strong>. Send feedback directly to their dashboard.
            </HeroText>
          </div>
        </HeroCard>

        <Card>
          <TitleRow>
            <SectionTitle>Viewing Goals for</SectionTitle>
            <GlobalMonthSelect value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
              {availableMonths.map(m => (
                <option key={m} value={m}>{m}</option>
              ))}
            </GlobalMonthSelect>
          </TitleRow>

          <Subtitle>
            Read their achievements and send weekly/routine feedback directly below. To formally score these, return to the dashboard and open their Appraisal Submission.
          </Subtitle>

          {loading ? (
            <StateBox>
              <Spinner />
              Loading staff records...
            </StateBox>
          ) : error ? (
            <StateBox type="error">{error}</StateBox>
          ) : (
            <>
              {/* DESKTOP TABLE */}
              <GoalsTableContainer>
                <GoalsTable>
                  <thead>
                    <tr>
                      <Th style={{ width: "31%" }}>Goals</Th>
                      <Th style={{ width: "23%" }}>Achievements</Th>
                      <Th style={{ width: "23%" }}>Comments</Th>
                      <Th style={{ width: "23%" }}>Admin Feedback</Th>
                    </tr>
                  </thead>

                  <tbody>
                    {submittedGoals.length > 0 ? (
                      <>
                        {monthlyGoals.map((month) => (
                          <React.Fragment key={month._id}>
                            <MonthlyTr>
                              <Td style={{ background: "#f0f9ff", borderLeft: "6px solid #3b82f6" }}>
                                <MonthlyBlock>
                                  <MonthlyTag>Monthly Goal</MonthlyTag>
                                  <div style={{ marginTop: "6px", marginBottom: "4px" }}>
                                    <UnitBadge>{getGoalUnit(month)}</UnitBadge>
                                  </div>
                                  <GoalText>{month.goal}</GoalText>
                                  <GoalMeta>{formatNiceDate(month.startDate)} — {formatNiceDate(month.deliveryDate)}</GoalMeta>
                                </MonthlyBlock>
                              </Td>
                              <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
                              <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
                              <Td style={{ background: "#f0f9ff", borderBottom: "1px solid #e0f2fe" }}></Td>
                            </MonthlyTr>

                            {filteredWeeklies.filter((w) => w.parentMonthlyGoal === month._id).map((week) => (
                              <WeeklyTr key={week._id}>
                                <Td>
                                  <WeeklyGoalWrap>
                                    <WeeklyTitle>{getWeekLabel(week.weeklyDeliveryDate)} Goal</WeeklyTitle>
                                    <GoalText>{week.goal}</GoalText>
                                    <GoalMeta>Due {formatNiceDate(week.weeklyDeliveryDate)}</GoalMeta>
                                  </WeeklyGoalWrap>
                                </Td>
                                <Td>
                                  {renderReadOnlyField(week.achievements, "No achievements submitted.")}
                                </Td>
                                <Td>
                                  {renderReadOnlyField(week.comments, "No comments added.")}
                                </Td>
                                <Td>
                                  {feedbackStatus[week._id] && (
                                    <InlineMessage type={feedbackStatus[week._id].type}>
                                      {feedbackStatus[week._id].text}
                                    </InlineMessage>
                                  )}
                                  
                                  <FieldTextarea
                                    value={editValues[`${week._id}_sup`] ?? week.superAdminComments?.text ?? ""} 
                                    onChange={(e) => handleEditChange(week._id, "sup", e.target.value)}
                                    placeholder="Type new feedback for this week..."
                                  />
                                  <SendButton
                                    onClick={() => saveFeedback(week._id)}
                                    disabled={updatingId === week._id}
                                  >
                                    {updatingId === week._id ? "Sending..." : "Send to Staff"}
                                  </SendButton>
                                </Td>
                              </WeeklyTr>
                            ))}
                          </React.Fragment>
                        ))}

                        {routineGoals.map((routine) => (
                          <tr key={routine._id}>
                            <Td style={{ borderLeft: "6px solid #ea580c" }}>
                              <MonthlyBlock>
                                <RoutineTag>Other Goal</RoutineTag>
                                <GoalText>{routine.goal}</GoalText>
                                <GoalMeta>Due {formatNiceDate(routine.deliveryDate)}</GoalMeta>
                              </MonthlyBlock>
                            </Td>
                            <Td>
                              {renderReadOnlyField(routine.achievements, "No achievements submitted.")}
                            </Td>
                            <Td>
                              {renderReadOnlyField(routine.comments, "No comments added.")}
                            </Td>
                            <Td>
                              {feedbackStatus[routine._id] && (
                                <InlineMessage type={feedbackStatus[routine._id].type}>
                                  {feedbackStatus[routine._id].text}
                                </InlineMessage>
                              )}
                              
                              <FieldTextarea
                                value={editValues[`${routine._id}_sup`] ?? routine.superAdminComments?.text ?? ""} 
                                onChange={(e) => handleEditChange(routine._id, "sup", e.target.value)}
                                placeholder="Type new feedback for this routine goal..."
                              />
                              <SendButton
                                onClick={() => saveFeedback(routine._id)}
                                disabled={updatingId === routine._id}
                              >
                                {updatingId === routine._id ? "Sending..." : "Send to Staff"}
                              </SendButton>
                            </Td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <Td colSpan="4"><NoData>No goals submitted yet for this month.</NoData></Td>
                      </tr>
                    )}
                  </tbody>
                </GoalsTable>
              </GoalsTableContainer>

              {/* MOBILE LAYOUT */}
              <GoalsMobileGrid>
                {submittedGoals.length > 0 ? (
                  <>
                    {monthlyGoals.map((month) => (
                      <React.Fragment key={month._id}>
                        <GoalCard>
                          <GoalCardHeader><Pill>Monthly Goal</Pill></GoalCardHeader>
                          <div style={{ marginBottom: "10px" }}><UnitBadge>{getGoalUnit(month)}</UnitBadge></div>
                          <GoalCardTitle>{month.goal}</GoalCardTitle>
                          <GoalCardMeta>{formatNiceDate(month.startDate)} — {formatNiceDate(month.deliveryDate)}</GoalCardMeta>
                        </GoalCard>

                        {filteredWeeklies.filter((w) => w.parentMonthlyGoal === month._id).map((week) => (
                          <GoalCard key={week._id}>
                            <GoalCardHeader>
                              <WeeklyTitle>{getWeekLabel(week.weeklyDeliveryDate)}</WeeklyTitle>
                              <Pill>Weekly</Pill>
                            </GoalCardHeader>
                            <GoalCardTitle>{week.goal}</GoalCardTitle>
                            <GoalCardMeta>Due {formatNiceDate(week.weeklyDeliveryDate)}</GoalCardMeta>
                            
                            <SmallLabel>Achievements</SmallLabel>
                            {renderReadOnlyField(week.achievements, "No achievements submitted.")}
                            
                            <SmallLabel>Comments</SmallLabel>
                            {renderReadOnlyField(week.comments, "No comments added.")}

                            <SmallLabel>Admin Feedback</SmallLabel>

                            {feedbackStatus[week._id] && (
                              <InlineMessage type={feedbackStatus[week._id].type}>
                                {feedbackStatus[week._id].text}
                              </InlineMessage>
                            )}
                            <FieldTextarea
                              value={editValues[`${week._id}_sup`] ?? week.superAdminComments?.text ?? ""} 
                              onChange={(e) => handleEditChange(week._id, "sup", e.target.value)}
                              placeholder="Type new feedback for this week..."
                            />
                            <SendButton
                              onClick={() => saveFeedback(week._id)}
                              disabled={updatingId === week._id}
                            >
                              {updatingId === week._id ? "Sending..." : "Send to Staff"}
                            </SendButton>
                          </GoalCard>
                        ))}
                      </React.Fragment>
                    ))}

                    {routineGoals.map((routine) => (
                      <GoalCard key={routine._id} variant="routine">
                        <GoalCardHeader><Pill variant="routine">Other Goal</Pill></GoalCardHeader>
                        <GoalCardTitle>{routine.goal}</GoalCardTitle>
                        <GoalCardMeta>Due {formatNiceDate(routine.deliveryDate)}</GoalCardMeta>
                        
                        <SmallLabel>Achievements</SmallLabel>
                        {renderReadOnlyField(routine.achievements, "No achievements submitted.")}
                        
                        <SmallLabel>Comments</SmallLabel>
                        {renderReadOnlyField(routine.comments, "No comments added.")}

                        <SmallLabel>Admin Feedback</SmallLabel>

                        {feedbackStatus[routine._id] && (
                          <InlineMessage type={feedbackStatus[routine._id].type}>
                            {feedbackStatus[routine._id].text}
                          </InlineMessage>
                        )}
                        <FieldTextarea
                          value={editValues[`${routine._id}_sup`] ?? routine.superAdminComments?.text ?? ""}
                          onChange={(e) => handleEditChange(routine._id, "sup", e.target.value)}
                          placeholder="Type new feedback for this routine goal..."
                        />
                        <SendButton
                          onClick={() => saveFeedback(routine._id)}
                          disabled={updatingId === routine._id}
                        >
                          {updatingId === routine._id ? "Sending..." : "Send to Staff"}
                        </SendButton>
                      </GoalCard>
                    ))}
                  </>
                ) : (
                  <EmptyCard>No goals submitted yet for this month.</EmptyCard>
                )}
              </GoalsMobileGrid>

              <PaginationContainer>
                {weeks.map((weekLabel, i) => (
                  <PageButton
                    key={i} className={currentPage === i + 1 ? "active" : ""} onClick={() => setCurrentPage(i + 1)} type="button"
                  >
                    {weekLabel}
                  </PageButton>
                ))}
              </PaginationContainer>
            </>
          )}
        </Card>
      </PageWrapper>
      <Footer />
    </Container>
  );
};

export default SuperAdminStaffGoals;